import DocMenuConfig from "@/core/config/MainMenuConfig";
import router from "@/router/index";
import utils from "@/utils/index";
import config from "@/configApp";
import MultiempresaService from "@/services/MultiempresaService";
import TributaAIService from "@/services/TributaAIService";

export const menu = {
  namespaced: true,
  state: { menu: [] },
  actions: {
    async montarMenu({ commit }, user) {
      try {
        var permissoes = user.User.TipoUsuario.Restricao;
        var permissoesEmitente =
          user.User.EmitenteTipoUsuario.EmitenteRestricao;
        var isAdministradorGeral =
          user.User.TipoUsuario.tipo === "Administrador";
        var possuiAcessoOperacionalMultiempresa = isAdministradorGeral;
        var possuiAcessoRelatoriosMultiempresa = isAdministradorGeral;
        var possuiAcessoLogsMultiempresa = isAdministradorGeral;
        var tributaAiHabilitado = false;
        var lojaVirtualHabilitada =
          user.User.Emitente.loja_virtual_habilitada === true;

        var rotas = [];

        try {
          var retEmpresasPermitidas =
            await MultiempresaService.GetEmpresasPermitidas();
          possuiAcessoOperacionalMultiempresa =
            possuiAcessoOperacionalMultiempresa ||
            (retEmpresasPermitidas.Data || []).length > 0;
        } catch (error) {
          possuiAcessoOperacionalMultiempresa =
            user.User.TipoUsuario.tipo === "Administrador";
        }

        try {
          var retGruposMultiempresa = await MultiempresaService.GetGrupos();
          var gruposMultiempresa = retGruposMultiempresa.Data || [];
          var idUsuarioAtual = user.User.id;

          possuiAcessoRelatoriosMultiempresa =
            possuiAcessoRelatoriosMultiempresa ||
            gruposMultiempresa.some((grupo) =>
              (grupo.permissoes_usuario || []).some(
                (permissao) =>
                  Number(permissao.id_usuario) === Number(idUsuarioAtual) &&
                  permissao.ativo === "1" &&
                  permissao.pode_visualizar_relatorios === "1"
              )
            );

          possuiAcessoLogsMultiempresa =
            possuiAcessoLogsMultiempresa ||
            gruposMultiempresa.some((grupo) =>
              (grupo.permissoes_usuario || []).some(
                (permissao) =>
                  Number(permissao.id_usuario) === Number(idUsuarioAtual) &&
                  permissao.ativo === "1" &&
                  permissao.pode_visualizar_logs === "1"
              )
            );
        } catch (error) {
          possuiAcessoRelatoriosMultiempresa =
            user.User.TipoUsuario.tipo === "Administrador";
          possuiAcessoLogsMultiempresa =
            user.User.TipoUsuario.tipo === "Administrador";
        }

        try {
          var retTributaAi = await TributaAIService.getHabilitado();
          tributaAiHabilitado = retTributaAi?.habilitado === true;
        } catch (error) {
          tributaAiHabilitado = false;
        }

        //#region Variáveis

        //#region Variáveis - Navegação principal
        var navegacao = {
          heading: "Gestão",
          route: `/${utils.getWL()}/principal`,
          pages: [],
        };

        var emitentesModulo = null;
        var emitentesRota = null;
        var softwareHouseModulo = null;
        var softwareHouseRota = null;
        var configuracaoWhiteLabelModulo = null;
        var configuracaoWhiteLabelRota = null;
        var restricoesModulo = null;
        var restricoesRota = null;
        var gerenciadorPainelGestorModulo = null;
        var gerenciadorPainelGestorRota = null;
        var gestaoConfiguracoesIntegracaoModulo = null;
        var gestaoConfiguracoesIntegracaoRota = null;
        var ajudasModulo = null;
        var ajudasRota = null;
        var releasesModulo = null;
        var releasesRota = null;
        var tributaAiGestaoModulo = null;
        var tributaAiGestaoRota = null;
        var revendaModulo = null;
        var licencaRecebivelModulo = null;
        //#endregion

        //#region Variáveis - Cadastros
        var cadastros = {
          heading: "Cadastros",
          route: `/${utils.getWL()}/cadastros`,
          pages: [],
        };

        var clientesModulo = null;
        var clientesRota = null;
        var produtosModulo = null;
        var produtosRota = null;
        var etiquetasModulo = null;
        var etiquetasRota = null;
        var transportadorasModulo = null;
        var transportadorasRota = null;
        var fornecedoresModulo = null;
        var fornecedoresRota = null;
        var vendedoresModulo = null;
        var vendedoresRota = null;
        var tecnicosModulo = null;
        var tecnicosRota = null;
        var motoristasModulo = null;
        var motoristasRota = null;
        //#endregion

        //#region Variáveis - Movimentação
        var movimentacao = {
          heading: "Movimentação",
          route: `/${utils.getWL()}/movimentacao`,
          pages: [],
        };

        var faturamentoModulo = null;
        var faturamentoRota = null;
        var cteModulo = null;
        var cteRota = null;
        var nfseModulo = null;
        var nfseRota = null;
        var gerenciadorNFeModulo = null;
        var gerenciadorNFeRota = null;
        var pedidosModulo = null;
        var pedidosRota = null;
        var ordensServicoModulo = null;
        var ordensServicoRota = null;
        var agendamentosModulo = null;
        var agendamentosRota = null;
        var pdvModulo = null;
        var pdvRota = null;
        var restauranteModulo = null;
        var compraModulo = null;
        var compraRota = null;
        //#endregion

        //#region Variáveis - Financeiro
        var financeiro = {
          heading: "Financeiro",
          route: `/${utils.getWL()}/financeiro`,
          pages: [],
        };

        var condicoesModulo = null;
        var condicoesRota = null;
        var especiesModulo = null;
        var especiesRota = null;
        var dashboardFinanceiroModulo = null;
        var fluxoCaixaModulo = null;
        var dashboardFinanceiroRota = null;
        var fluxoCaixaRota = null;
        var dreGerencialRota = null;
        var indicadoresFinanceirosRota = null;
        var relatoriosFinanceirosRota = null;
        var conciliacaoBancariaModulo = null;
        var conciliacaoBancariaRota = null;
        var custosModulo = null;
        var custosRota = null;
        var contasModulo = null;
        var contasRota = null;
        var receberModulo = null;
        var receberRota = null;
        var pagarModulo = null;
        var pagarRota = null;
        //#endregion

        //#region Variáveis - Auxiliares
        var auxiliares = {
          heading: "Auxiliares",
          route: `/${utils.getWL()}/auxiliares`,
          pages: [],
        };

        var auxiliaresModulo = null;
        //#endregion

        //#region Variáveis - Fiscal
        var fiscal = {
          heading: "Fiscal",
          route: `/${utils.getWL()}/fiscal`,
          pages: [],
        };

        var sintegraModulo = null;
        var sintegraRota = null;
        var spedModulo = null;
        var spedContribuicoesRota = null;
        var spedFiscalRota = null;
        var spedContabilistaRota = null;
        var spedSubmenus = [];
        //#endregion

        //#region Variáveis - Relatórios
        var relatorios = {
          heading: "Relatórios",
          route: `/${utils.getWL()}/relatorios`,
          pages: [],
        };

        var relatoriosModulo = null;
        var relatoriosRota = null;
        var multiempresas = {
          heading: "Multiempresas",
          route: `/${utils.getWL()}/multiempresas`,
          pages: [],
        };
        var multiempresaGestaoModulo = null;
        var multiempresaRelatoriosModulo = null;
        var multiempresaLogsModulo = null;
        //#endregion

        //#region Variáveis - Configurações
        var configuracoes = {
          heading: "Configurações",
          route: `/${utils.getWL()}/configuracoes`,
          pages: [],
        };

        var usuariosModulo = null;
        var usuariosRota = null;
        var emitenteRestricoesModulo = null;
        var emitenteRestricoesRota = null;
        var configuracoesModulo = null;
        var configuracoesRota = null;
        var auditoriaModulo = null;
        var auditoriaRota = null;
        //#endregion

        //#region Variáveis - Suporte
        var suporte = {
          heading: "Suporte",
          route: `/${utils.getWL()}/suporte`,
          pages: [],
        };

        var suporteAjudaModulo = null;
        var suporteAjudaRota = null;
        var ticketModulo = null;
        var ticketRota = null;

        var licenca = {
          heading: "Licença",
          route: `/${utils.getWL()}/licenca`,
          pages: [],
        };

        var licencaFaturaEmitenteModulo = null;
        var licencaFaturaEmitenteRota = null;

        //#endregion

        //#endregion

        //#region Menus

        //#region Menu - Navegação principal

        //#region Menu - Navegação principal - Empresas
        if (
          user.User.TipoUsuario.tipo === "Administrador" ||
          user.User.TipoUsuario.tipo === "Distribuidor Master" ||
          user.User.TipoUsuario.tipo === "Distribuidor" ||
          user.User.TipoUsuario.tipo === "Revenda"
        ) {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Emitente.Consultar"
            )
          ) {
            emitentesModulo = {
              ordem: 1,
              sectionTitle: "Empresas",
              route: `/${utils.getWL()}/principal/empresas`,
              svgIcon: "media/icons/duotune/ecommerce/ecm004.svg",
              fontIcon: "bi-shop",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/empresas/consultar`,
                },
              ],
            };

            emitentesRota = {
              path: "/:url/principal/empresas/consultar",
              name: "principal/empresas/consultar",
              component: () => import("@/views/empresas/Consultar.vue"),
              meta: {
                pageTitle: "Empresas",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(emitentesModulo);
            rotas.push(emitentesRota);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Emitente.Incluir"
            )
          ) {
            var emitenteAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/principal/empresas/editar`,
            };

            var emitenteAdicionarRotas = {
              path: "/:url/principal/empresas/editar",
              name: "principal/empresas/editar",
              component: () => import("@/views/empresas/Editar.vue"),
              meta: {
                pageTitle: "Empresas",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (emitentesModulo !== null) {
              emitentesModulo.sub.push(emitenteAdicionarModulo);
            }

            rotas.push(emitenteAdicionarRotas);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Emitente.Alterar"
            )
          ) {
            var emitenteEditarRotas = {
              path: "/:url/principal/empresas/editar/:id",
              name: "principal/empresas/editar/:id",
              component: () => import("@/views/empresas/Editar.vue"),
              meta: {
                pageTitle: "Empresas",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(emitenteEditarRotas);
          }
        }

        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) =>
                modulo.regra == "Permitir.EmitenteSoftwareHouse.Consultar"
            )
          ) {
            var emitenteSoftwareHouseConsultarModulo = {
              heading: "Gerenciar",
              route: `/${utils.getWL()}/principal/empresas/gerenciar`,
            };

            var emitenteSoftwareHouseConsultarRotas = {
              path: "/:url/principal/empresas/gerenciar",
              name: "principal/empresas/gerenciar",
              component: () => import("@/views/empresas/Gerenciar.vue"),
              meta: {
                pageTitle: "Empresas",
                breadcrumbs: ["Consultar", "Gerenciar"],
              },
            };

            if (emitentesModulo !== null) {
              emitentesModulo.sub.push(emitenteSoftwareHouseConsultarModulo);
            }

            rotas.push(emitenteSoftwareHouseConsultarRotas);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - SoftwareHouse
        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.SoftwareHouse.Consultar"
            )
          ) {
            softwareHouseModulo = {
              ordem: 2,
              sectionTitle: "SoftwareHouse",
              route: `/${utils.getWL()}/principal/softwarehouse`,
              svgIcon: "media/icons/duotune/finance/fin001.svg",
              fontIcon: "bi-house-door",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/softwarehouse/consultar`,
                },
              ],
            };

            softwareHouseRota = {
              path: "/:url/principal/softwarehouse/consultar",
              name: "principal/softwareHouse/consultar",
              component: () => import("@/views/softwarehouse/Consultar.vue"),
              meta: {
                pageTitle: "SoftwareHouse",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(softwareHouseModulo);
            rotas.push(softwareHouseRota);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.SoftwareHouse.Incluir"
            )
          ) {
            var softwarehouseAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/principal/softwarehouse/editar`,
            };

            var softwarehouseAdicionarRotas = {
              path: "/:url/principal/softwarehouse/editar",
              name: "principal/softwarehouse/editar",
              component: () => import("@/views/softwarehouse/Editar.vue"),
              meta: {
                pageTitle: "SoftwareHouse",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (softwareHouseModulo !== null) {
              softwareHouseModulo.sub.push(softwarehouseAdicionarModulo);
            }

            rotas.push(softwarehouseAdicionarRotas);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.SoftwareHouse.Alterar"
            )
          ) {
            var softwarehouseEditarRotas = {
              path: "/:url/principal/softwarehouse/editar/:id",
              name: "principal/softwarehouse/editar/:id",
              component: () => import("@/views/softwarehouse/Editar.vue"),
              meta: {
                pageTitle: "SoftwareHouse",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(softwarehouseEditarRotas);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - ConfiguracaoWhiteLabel
        if (
          user.User.TipoUsuario.tipo === "Administrador" ||
          user.User.TipoUsuario.tipo === "Distribuidor Master" ||
          user.User.TipoUsuario.tipo === "Distribuidor" ||
          user.User.TipoUsuario.tipo === "Revenda"
        ) {
          if (
            permissoes.find(
              (modulo) =>
                modulo.regra == "Permitir.ConfiguracaoWhiteLabel.Consultar"
            )
          ) {
            configuracaoWhiteLabelModulo = {
              ordem: 3,
              sectionTitle: "White Label",
              route: `/${utils.getWL()}/principal/configuracaowhitelabel`,
              svgIcon: "media/icons/duotune/general/gen062.svg",
              fontIcon: "bi bi-display",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/configuracaowhitelabel/consultar`,
                },
              ],
            };

            configuracaoWhiteLabelRota = {
              path: "/:url/principal/configuracaowhitelabel/consultar",
              name: "principal/configuracaowhitelabel/consultar",
              component: () => import("@/views/whitelabel/Consultar.vue"),
              meta: {
                pageTitle: "White Label",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(configuracaoWhiteLabelModulo);
            rotas.push(configuracaoWhiteLabelRota);
          }

          if (
            user.User.TipoUsuario.tipo === "Administrador" &&
            permissoes.find(
              (modulo) =>
                modulo.regra == "Permitir.ConfiguracaoWhiteLabel.Incluir"
            )
          ) {
            var configuracaoWhiteLabelAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/principal/configuracaowhitelabel/editar`,
            };

            var configuracaoWhiteLabelAdicionarRotas = {
              path: "/:url/principal/configuracaowhitelabel/editar",
              name: "principal/configuracaowhitelabel/editar",
              component: () => import("@/views/whitelabel/Editar.vue"),
              meta: {
                pageTitle: "White Label",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (configuracaoWhiteLabelModulo !== null) {
              configuracaoWhiteLabelModulo.sub.push(
                configuracaoWhiteLabelAdicionarModulo
              );
            }

            rotas.push(configuracaoWhiteLabelAdicionarRotas);
          }

          if (
            permissoes.find(
              (modulo) =>
                modulo.regra == "Permitir.ConfiguracaoWhiteLabel.Alterar"
            )
          ) {
            var configuracaoWhiteLabelEditarRotas = {
              path: "/:url/principal/configuracaowhitelabel/editar/:id",
              name: "principal/configuracaowhitelabel/editar/:id",
              component: () => import("@/views/whitelabel/Editar.vue"),
              meta: {
                pageTitle: "White Label",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(configuracaoWhiteLabelEditarRotas);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - Restrições Administrativas
        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Restricao.Consultar"
            )
          ) {
            restricoesModulo = {
              ordem: 4,
              sectionTitle: "Restrições Administrativas",
              route: `/${utils.getWL()}/principal/restricoes`,
              svgIcon: "media/icons/duotune/general/gen051.svg",
              fontIcon: "bi-shield-lock",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/restricoes/consultar`,
                },
              ],
            };

            restricoesRota = {
              path: "/:url/principal/restricoes/consultar",
              name: "principal/restricoes/consultar",
              component: () => import("@/views/restricoes/Consultar.vue"),
              meta: {
                pageTitle: "Restrições",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(restricoesModulo);
            rotas.push(restricoesRota);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.RestricaoPadrao.Consultar"
            )
          ) {
            var restricoesPadraoConsultarModulo = {
              heading: "Gerenciar",
              route: `/${utils.getWL()}/principal/restricoes/gerenciar`,
            };

            var restricoesPadraoConsultarRotas = {
              path: "/:url/principal/restricoes/gerenciar",
              name: "principal/restricoes/gerenciar",
              component: () => import("@/views/restricoes/Gerenciar.vue"),
              meta: {
                pageTitle: "Restrições",
                breadcrumbs: ["Consultar", "Gerenciar"],
              },
            };

            if (restricoesModulo !== null) {
              restricoesModulo.sub.push(restricoesPadraoConsultarModulo);
            }

            rotas.push(restricoesPadraoConsultarRotas);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - Painel do Gestor
        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Gestor.Gerenciar"
            )
          ) {
            gerenciadorPainelGestorModulo = {
              ordem: 5,
              sectionTitle: "Painel do Gestor",
              route: `/${utils.getWL()}/principal/gestor`,
              svgIcon: "media/icons/duotune/general/gen019.svg",
              fontIcon: "bi bi-toggles",
              sub: [
                {
                  heading: "Gerenciar",
                  route: `/${utils.getWL()}/principal/gestor/gerenciar`,
                },
                {
                  heading: "Atualizações PDV",
                  route: `/${utils.getWL()}/principal/gestor/atualizacoes-pdv`,
                },
                {
                  heading: "Atualizações Gway Agente",
                  route: `/${utils.getWL()}/principal/gestor/atualizacoes-gway-agente`,
                },
              ],
            };

            gerenciadorPainelGestorRota = {
              path: "/:url/principal/gestor/gerenciar",
              name: "principal/gestor/gerenciar",
              component: () => import("@/views/gestor/Gerenciar.vue"),
              meta: {
                pageTitle: "Painel do Gestor",
                breadcrumbs: ["Gerenciar"],
              },
            };

            navegacao.pages.push(gerenciadorPainelGestorModulo);
            rotas.push(gerenciadorPainelGestorRota);
            rotas.push({
              path: "/:url/principal/gestor/atualizacoes-pdv",
              name: "principal/gestor/atualizacoes-pdv",
              component: () => import("@/views/pdv/atualizacoes/Consultar.vue"),
              meta: {
                pageTitle: "Atualizações do PDV",
                breadcrumbs: ["Painel do Gestor", "Atualizações PDV"],
              },
            });
            rotas.push({
              path: "/:url/principal/gestor/atualizacoes-gway-agente",
              name: "principal/gestor/atualizacoes-gway-agente",
              component: () =>
                import("@/views/gway-agente/atualizacoes/Consultar.vue"),
              meta: {
                pageTitle: "Atualizações do Gway Agente",
                breadcrumbs: ["Painel do Gestor", "Atualizações Gway Agente"],
              },
            });
          }
        }
        //#endregion

        //#region Menu - Navegação principal - Configurações
        if (
          (user.User.TipoUsuario.tipo === "Administrador" ||
            user.User.TipoUsuario.tipo === "Distribuidor Master" ||
            user.User.TipoUsuario.tipo === "Distribuidor" ||
            user.User.TipoUsuario.tipo === "Revenda") &&
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Configuracao.Consultar"
          )
        ) {
          gestaoConfiguracoesIntegracaoModulo = {
            ordem: 11,
            sectionTitle: "Configurações",
            route: `/${utils.getWL()}/principal/configuracoes/chaves-integracao`,
            svgIcon: "media/icons/duotune/general/gen024.svg",
            fontIcon: "bi bi-gear",
            sub: [
              {
                heading: "Chaves de integração",
                route: `/${utils.getWL()}/principal/configuracoes/chaves-integracao`,
              },
            ],
          };

          gestaoConfiguracoesIntegracaoRota = {
            path: "/:url/principal/configuracoes/chaves-integracao",
            name: "principal/configuracoes/chaves-integracao",
            component: () =>
              import("@/views/gestor/IntegracaoExternaChaveGestao.vue"),
            meta: {
              pageTitle: "Chaves de integração",
              breadcrumbs: ["Gestão", "Configurações", "Chaves de integração"],
            },
          };

          navegacao.pages.push(gestaoConfiguracoesIntegracaoModulo);
          rotas.push(gestaoConfiguracoesIntegracaoRota);

          gestaoConfiguracoesIntegracaoModulo.sub.push({
            heading: "Loja virtual",
            route: `/${utils.getWL()}/principal/configuracoes/loja-virtual`,
          });
          rotas.push({
            path: "/:url/principal/configuracoes/loja-virtual",
            name: "principal/configuracoes/loja-virtual",
            component: () => import("@/views/gestor/LojaVirtualGestao.vue"),
            meta: {
              pageTitle: "Loja virtual",
              breadcrumbs: ["Gestão", "Configurações", "Loja virtual"],
            },
          });
        }
        //#endregion

        //#region Menu - Navegação principal - Gestão Revenda
        if (
          permissoes.find(
            (modulo) => modulo.regra == "Permitir.GestaoRevendas.Gerenciar"
          )
        ) {
          revendaModulo = {
            ordem: 6,
            sectionTitle: "Gerenciar Revenda",
            route: `/${utils.getWL()}/principal/revenda`,
            svgIcon: "media/icons/duotune/communication/com005.svg",
            fontIcon: "bi bi-toggles",
            sub: [],
          };

          if (user.User.TipoUsuario.tipo === "Administrador") {
            if (
              permissoes.find(
                (modulo) =>
                  modulo.regra == "Permitir.DistribuidorMaster.Consultar"
              )
            ) {
              revendaModulo.sub.push({
                heading: "Distribuidor Master",
                route: `/${utils.getWL()}/principal/revenda/distribuidormaster`,
              });

              let distribuidorMasterRotas = {
                path: "/:url/principal/revenda/distribuidormaster",
                name: "principal/revenda/distribuidormaster",
                component: () =>
                  import("@/views/revenda/distribuidormaster/Consultar.vue"),
                meta: {
                  pageTitle: "Distribuidor Master",
                  breadcrumbs: ["Revenda", "Distribuidor Master", "Consultar"],
                },
              };

              rotas.push(distribuidorMasterRotas);
            }

            if (
              permissoes.find(
                (modulo) =>
                  modulo.regra == "Permitir.DistribuidorMaster.Incluir"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/distribuidormaster/editar",
                name: "principal/revenda/distribuidormaster/editar",
                component: () =>
                  import("@/views/revenda/distribuidormaster/Editar.vue"),
                meta: {
                  pageTitle: "Distribuidor Master",
                  breadcrumbs: ["Revenda", "Distribuidor Master", "Editar"],
                },
              };

              rotas.push(incluir);
            }

            if (
              permissoes.find(
                (modulo) =>
                  modulo.regra == "Permitir.DistribuidorMaster.Alterar"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/distribuidormaster/editar/:id",
                name: "principal/revenda/distribuidormaster/editar/:id",
                component: () =>
                  import("@/views/revenda/distribuidormaster/Editar.vue"),
                meta: {
                  pageTitle: "Distribuidor Master",
                  breadcrumbs: ["Revenda", "Distribuidor Master", "Editar"],
                },
              };

              rotas.push(incluir);
            }
          }

          if (
            user.User.TipoUsuario.tipo === "Administrador" ||
            user.User.TipoUsuario.tipo === "Distribuidor Master"
          ) {
            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Distribuidor.Consultar"
              )
            ) {
              revendaModulo.sub.push({
                heading: "Distribuidor",
                route: `/${utils.getWL()}/principal/revenda/distribuidor`,
              });

              let distribuidorRotas = {
                path: "/:url/principal/revenda/distribuidor",
                name: "principal/revenda/distribuidor",
                component: () =>
                  import("@/views/revenda/distribuidor/Consultar.vue"),
                meta: {
                  pageTitle: "Distribuidor",
                  breadcrumbs: ["Revenda", "Distribuidor", "Consultar"],
                },
              };

              rotas.push(distribuidorRotas);
            }

            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Distribuidor.Incluir"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/distribuidor/editar",
                name: "principal/revenda/distribuidor/editar",
                component: () =>
                  import("@/views/revenda/distribuidor/Editar.vue"),
                meta: {
                  pageTitle: "Distribuidor",
                  breadcrumbs: ["Revenda", "Distribuidor", "Editar"],
                },
              };

              rotas.push(incluir);
            }

            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Distribuidor.Alterar"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/distribuidor/editar/:id",
                name: "principal/revenda/distribuidor/editar/:id",
                component: () =>
                  import("@/views/revenda/distribuidor/Editar.vue"),
                meta: {
                  pageTitle: "Distribuidor",
                  breadcrumbs: ["Revenda", "Distribuidor", "Editar"],
                },
              };

              rotas.push(incluir);
            }
          }

          if (
            user.User.TipoUsuario.tipo === "Administrador" ||
            user.User.TipoUsuario.tipo === "Distribuidor Master" ||
            user.User.TipoUsuario.tipo === "Distribuidor"
          ) {
            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Revenda.Consultar"
              )
            ) {
              revendaModulo.sub.push({
                heading: "Revenda",
                route: `/${utils.getWL()}/principal/revenda/revenda`,
              });

              let revendaRotas = {
                path: "/:url/principal/revenda/revenda",
                name: "principal/revenda/revenda",
                component: () =>
                  import("@/views/revenda/revenda/Consultar.vue"),
                meta: {
                  pageTitle: "Revenda",
                  breadcrumbs: ["Revenda", "Revenda", "Consultar"],
                },
              };

              rotas.push(revendaRotas);
            }

            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Revenda.Incluir"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/revenda/editar",
                name: "principal/revenda/revenda/editar",
                component: () => import("@/views/revenda/revenda/Editar.vue"),
                meta: {
                  pageTitle: "Revenda",
                  breadcrumbs: ["Revenda", "Revenda", "Editar"],
                },
              };

              rotas.push(incluir);
            }

            if (
              permissoes.find(
                (modulo) => modulo.regra == "Permitir.Revenda.Alterar"
              )
            ) {
              let incluir = {
                path: "/:url/principal/revenda/revenda/editar/:id",
                name: "principal/revenda/revenda/editar/:id",
                component: () => import("@/views/revenda/revenda/Editar.vue"),
                meta: {
                  pageTitle: "Revenda",
                  breadcrumbs: ["Revenda", "Revenda", "Editar"],
                },
              };

              rotas.push(incluir);
            }
          }

          //Vendedor Revenda
          // if (
          //   user.User.TipoUsuario.tipo === "Administrador" ||
          //   user.User.TipoUsuario.tipo === "Distribuidor Master" ||
          //   user.User.TipoUsuario.tipo === "Distribuidor" ||
          //   user.User.TipoUsuario.tipo === "Revenda"
          // ) {
          //   if (
          //     permissoes.find(
          //       (modulo) => modulo.regra == "Permitir.VendedorRevenda.Consultar"
          //     )
          //   ) {
          //     revendaModulo.sub.push({
          //       heading: "Vendedores Revenda",
          //       route: `/${utils.getWL()}/principal/revenda/vendedorrevenda`,
          //     });

          //     let vendedorRevendaRotas = {
          //       path: "/:url/principal/revenda/vendedorrevenda",
          //       name: "principal/revenda/vendedorrevenda",
          //       component: () =>
          //         import("@/views/revenda/vendedorrevenda/Consultar.vue"),
          //       meta: {
          //         pageTitle: "Vendedores Revenda",
          //         breadcrumbs: ["Revenda", "Vendedores Revenda", "Consultar"],
          //       },
          //     };

          //     rotas.push(vendedorRevendaRotas);
          //   }
          // }

          if (revendaModulo.sub && revendaModulo.sub.length > 0) {
            navegacao.pages.push(revendaModulo);
          }
        }
        //#endregion

        //#region Menu - Navegação principal - Licença Recebiveis

        if (
          user.User.TipoUsuario.tipo === "Administrador" ||
          user.User.TipoUsuario.tipo === "Distribuidor Master" ||
          user.User.TipoUsuario.tipo === "Distribuidor" ||
          user.User.TipoUsuario.tipo === "Revenda"
        ) {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.LicencaRecebivel.Consultar"
            )
          ) {
            licencaRecebivelModulo = {
              ordem: 7,
              sectionTitle: "Financeiro - Licenças",
              route: `/${utils.getWL()}/principal/licencarecebivel`,
              svgIcon: "media/icons/duotune/finance/fin005.svg",
              fontIcon: "bi bi-toggles",
              sub: [],
            };

            licencaRecebivelModulo.sub.push({
              heading:
                user.User.TipoUsuario.tipo === "Administrador" ||
                user.User.TipoUsuario.tipo === "Distribuidor Master"
                  ? "Faturas a Receber"
                  : "Faturas a Pagar",
              route: `/${utils.getWL()}/principal/licencarecebivel/consultar`,
            });

            let licencaRecebivelRotas = {
              path: "/:url/principal/licencarecebivel/consultar",
              name: "principal/licencarecebivel/consultar",
              component: () => import("@/views/licencarecebivel/Consultar.vue"),
              meta: {
                pageTitle: "Financeiro - Faturas",
                breadcrumbs: ["Financeiro - Faturas", "Consultar"],
              },
            };

            /*if (user.User.TipoUsuario.tipo === "Revenda") {
              if (
                permissoes.find(
                  (modulo) =>
                    modulo.regra == "Permitir.LicencaRecebivel.Consultar"
                )
              ) {
                let consultarReceberModulo = {
                  heading: "Faturas a Receber",
                  route: `/${utils.getWL()}/principal/licencarecebivel/consultarreceber`,
                };

                let consultarReceberRotas = {
                  path: "/:url/principal/licencarecebivel/consultarreceber",
                  name: "principal/licencarecebivel/consultarreceber",
                  component: () =>
                    import("@/views/licencarecebivel/ConsultarReceber.vue"),
                  meta: {
                    pageTitle: "Consultar Receber",
                    breadcrumbs: ["Consultar Receber", "Gerenciar"],
                  },
                };

                if (licencaRecebivelModulo !== null) {
                  licencaRecebivelModulo.sub.push(consultarReceberModulo);
                }

                rotas.push(consultarReceberRotas);
              }
            }*/

            licencaRecebivelModulo.sub.push({
              heading: "Licenças",
              route: `/${utils.getWL()}/principal/licencarecebivel/consultarlicencas`,
            });

            let licencasRotas = {
              path: "/:url/principal/licencarecebivel/consultarlicencas",
              name: "principal/licencarecebivel/consultarlicencas",
              component: () =>
                import("@/views/licencarecebivel/ConsultarLicencas.vue"),
              meta: {
                pageTitle: "Financeiro - Licenças",
                breadcrumbs: ["Financeiro - Licenças", "Consultar"],
              },
            };

            rotas.push(licencaRecebivelRotas);
            rotas.push(licencasRotas);

            if (
              licencaRecebivelModulo.sub &&
              licencaRecebivelModulo.sub.length > 0
            ) {
              navegacao.pages.push(licencaRecebivelModulo);
            }
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.AtualizacaoPlano.Gerenciar"
            )
          ) {
            let gerenciarAtualizacaoPlanoModulo = {
              heading: "Atualizações de Plano",
              route: `/${utils.getWL()}/principal/licencarecebivel/atualizacoesplano`,
            };

            let gerenciarAtualizacaoPlanoRotas = {
              path: "/:url/principal/licencarecebivel/atualizacoesplano",
              name: "principal/licencarecebivel/atualizacoesplano",
              component: () =>
                import("@/views/licencarecebivel/AtualizacoesPlano.vue"),
              meta: {
                pageTitle: "Atualizações de Plano",
                breadcrumbs: ["Atualizações de Plano", "Gerenciar"],
              },
            };

            if (licencaRecebivelModulo !== null) {
              licencaRecebivelModulo.sub.push(gerenciarAtualizacaoPlanoModulo);
            }

            rotas.push(gerenciarAtualizacaoPlanoRotas);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.BloqueioLicenca.Consultar"
            )
          ) {
            let consultarBloqueioLicenca = {
              heading: "Bloqueio",
              route: `/${utils.getWL()}/principal/licencarecebivel/consultarbloqueio`,
            };

            let consultarBloqueioLicencaRotas = {
              path: "/:url/principal/licencarecebivel/consultarbloqueio",
              name: "principal/licencarecebivel/consultarbloqueio",
              component: () =>
                import("@/views/licencarecebivel/ConsultarBloqueio.vue"),
              meta: {
                pageTitle: "Bloqueio",
                breadcrumbs: ["Bloqueio", "Consultar"],
              },
            };

            if (licencaRecebivelModulo !== null) {
              licencaRecebivelModulo.sub.push(consultarBloqueioLicenca);
            }

            rotas.push(consultarBloqueioLicencaRotas);
          }
        }

        //#endregion

        //#region Menu - Navegação principal - Ajuda
        if (user.User.TipoUsuario.tipo === "Administrador") {
          releasesModulo = {
            ordem: 9,
            sectionTitle: "Releases",
            route: `/${utils.getWL()}/principal/releases`,
            svgIcon: "media/icons/duotune/general/gen003.svg",
            fontIcon: "bi-megaphone",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/principal/releases/consultar`,
              },
              {
                heading: "Adicionar",
                route: `/${utils.getWL()}/principal/releases/editar`,
              },
            ],
          };
          releasesRota = {
            path: "/:url/principal/releases/consultar",
            name: "principal/releases/consultar",
            component: () => import("@/views/releases/Consultar.vue"),
            meta: { pageTitle: "Releases", breadcrumbs: ["Consultar"] },
          };
          navegacao.pages.push(releasesModulo);
          rotas.push(releasesRota);
          rotas.push({
            path: "/:url/principal/releases/editar",
            name: "principal/releases/editar",
            component: () => import("@/views/releases/Editar.vue"),
            meta: {
              pageTitle: "Releases",
              breadcrumbs: ["Consultar", "Editar"],
            },
          });
          rotas.push({
            path: "/:url/principal/releases/editar/:id",
            name: "principal/releases/editar/:id",
            component: () => import("@/views/releases/Editar.vue"),
            meta: {
              pageTitle: "Releases",
              breadcrumbs: ["Consultar", "Editar"],
            },
          });
        }
        if (user.User.TipoUsuario.tipo === "Administrador") {
          tributaAiGestaoModulo = {
            ordem: 10,
            sectionTitle: "Tributa AI",
            route: `/${utils.getWL()}/principal/tributa-ai`,
            svgIcon: "media/icons/duotune/ecommerce/ecm008.svg",
            fontIcon: "bi-calculator",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/principal/tributa-ai/consultar`,
              },
              {
                heading: "Adicionar",
                route: `/${utils.getWL()}/principal/tributa-ai/adicionar`,
              },
              {
                heading: "Orçamento",
                route: `/${utils.getWL()}/principal/tributa-ai/orcamento`,
              },
            ],
          };
          tributaAiGestaoRota = {
            path: "/:url/principal/tributa-ai/consultar",
            name: "principal/tributa-ai/consultar",
            component: () => import("@/views/gestor/TributaAIGestao.vue"),
            meta: { pageTitle: "Tributa AI", breadcrumbs: ["Consultar"] },
          };
          navegacao.pages.push(tributaAiGestaoModulo);
          rotas.push(tributaAiGestaoRota);
          rotas.push({
            path: "/:url/principal/tributa-ai/adicionar",
            name: "principal/tributa-ai/adicionar",
            component: () => import("@/views/gestor/TributaAIGestao.vue"),
            meta: { pageTitle: "Tributa AI", breadcrumbs: ["Adicionar"] },
          });
          rotas.push({
            path: "/:url/principal/tributa-ai/orcamento",
            name: "principal/tributa-ai/orcamento",
            component: () => import("@/views/gestor/TributaAIOrcamento.vue"),
            meta: { pageTitle: "Tributa AI", breadcrumbs: ["Orçamento"] },
          });
        }
        if (user.User.TipoUsuario.tipo === "Administrador") {
          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Ajuda.Consultar"
            )
          ) {
            ajudasModulo = {
              ordem: 8,
              sectionTitle: "Ajuda",
              route: `/${utils.getWL()}/principal/ajuda`,
              svgIcon: "media/icons/duotune/general/gen046.svg",
              fontIcon: "bi-question-circle-fill",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/principal/ajuda/consultar`,
                },
              ],
            };

            ajudasRota = {
              path: "/:url/principal/ajuda/consultar",
              name: "principal/ajuda/consultar",
              component: () => import("@/views/ajuda/Consultar.vue"),
              meta: {
                pageTitle: "Ajuda",
                breadcrumbs: ["Consultar"],
              },
            };

            navegacao.pages.push(ajudasModulo);
            rotas.push(ajudasRota);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Ajuda.Incluir"
            )
          ) {
            var ajudaAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/principal/ajuda/editar`,
            };

            var ajudaAdicionarRotas = {
              path: "/:url/principal/ajuda/editar",
              name: "principal/ajuda/editar",
              component: () => import("@/views/ajuda/Editar.vue"),
              meta: {
                pageTitle: "Ajuda",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (ajudasModulo !== null) {
              ajudasModulo.sub.push(ajudaAdicionarModulo);
            }

            rotas.push(ajudaAdicionarRotas);
          }

          if (
            permissoes.find(
              (modulo) => modulo.regra == "Permitir.Ajuda.Alterar"
            )
          ) {
            var ajudaEditarRotas = {
              path: "/:url/principal/ajuda/editar/:id",
              name: "principal/ajuda/editar/:id",
              component: () => import("@/views/ajuda/Editar.vue"),
              meta: {
                pageTitle: "Ajuda",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(ajudaEditarRotas);
          }
        }
        //#endregion

        //#endregion

        //#region Menu - Cadastros

        //#region Menu - Cadastros - Clientes
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Cliente.Consultar"
          )
        ) {
          clientesModulo = {
            ordem: 1,
            sectionTitle: "Clientes",
            route: `/${utils.getWL()}/cadastros/clientes`,
            svgIcon: "media/icons/duotune/communication/com005.svg",
            fontIcon: "bi-file-person-fill",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/clientes/consultar`,
              },
            ],
          };

          clientesRota = {
            path: "/:url/cadastros/clientes/consultar",
            name: "cadastros/clientes/consultar",
            component: () => import("@/views/clientes/Consultar.vue"),
            meta: {
              pageTitle: "Clientes",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(clientesModulo);
          rotas.push(clientesRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Cliente.Incluir"
          )
        ) {
          var clientesAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/clientes/editar`,
          };

          var clientesAdicionarRotas = {
            path: "/:url/cadastros/clientes/editar",
            name: "cadastros/clientes/editar",
            component: () => import("@/views/clientes/Editar.vue"),
            meta: {
              pageTitle: "Clientes",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (clientesModulo !== null) {
            clientesModulo.sub.push(clientesAdicionarModulo);
          }

          rotas.push(clientesAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Cliente.Alterar"
          )
        ) {
          var clientesEditarRotas = {
            path: "/:url/cadastros/clientes/editar/:id",
            name: "cadastros/clientes/editar/:id",
            component: () => import("@/views/clientes/Editar.vue"),
            meta: {
              pageTitle: "Clientes",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(clientesEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Produtos
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Produto.Consultar"
          )
        ) {
          produtosModulo = {
            ordem: 1,
            sectionTitle: "Produtos",
            route: `/${utils.getWL()}/cadastros/produtos`,
            svgIcon: "media/icons/duotune/ecommerce/ecm009.svg",
            fontIcon: "bi-boxes",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/produtos/consultar`,
              },
            ],
          };

          produtosRota = {
            path: "/:url/cadastros/produtos/consultar",
            name: "cadastros/produtos/consultar",
            component: () => import("@/views/produtos/Consultar.vue"),
            meta: {
              pageTitle: "Produtos",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(produtosModulo);
          rotas.push(produtosRota);

          if (
            lojaVirtualHabilitada &&
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Produto.Alterar"
            )
          ) {
            rotas.push({
              path: "/:url/cadastros/produtos/loja-online",
              name: "cadastros/produtos/loja-online",
              component: () =>
                import("@/views/produtos/ConfiguracaoLojaOnline.vue"),
              meta: {
                pageTitle: "Configurar loja online",
                breadcrumbs: ["Produtos", "Loja online", "Configurações"],
              },
            });
            rotas.push({
              path: "/:url/cadastros/produtos/catalogo-online",
              name: "cadastros/produtos/catalogo-online",
              component: () => import("@/views/produtos/CatalogoOnline.vue"),
              meta: {
                pageTitle: "Catálogo online",
                breadcrumbs: ["Produtos", "Catálogo online"],
              },
            });
          }

          if (
            user.User.TipoUsuario.tipo === "Administrador" ||
            permissoesEmitente.find(
              (modulo) =>
                modulo.regra == "Permitir.TributaAI.Snapshot.Consultar"
            )
          ) {
            rotas.push({
              path: "/:url/cadastros/produtos/tributa-ai",
              name: "cadastros/produtos/tributa-ai",
              component: () => import("@/views/produtos/TributaAI.vue"),
              meta: {
                pageTitle: "Tributa AI",
                breadcrumbs: ["Produtos", "Tributa AI"],
              },
            });
          }

          var produtosRelatoriosModulo = {
            heading: "Relatórios",
            route: `/${utils.getWL()}/cadastros/produtos/relatorios/consultar`,
          };

          var produtosRelatoriosRotas = {
            path: "/:url/cadastros/produtos/relatorios/consultar",
            name: "cadastros/produtos/relatorios/consultar",
            component: () =>
              import("@/views/produtos/relatorios/Consultar.vue"),
            meta: {
              pageTitle: "Relatórios de Produtos",
              breadcrumbs: ["Produtos", "Relatórios"],
            },
          };

          rotas.push(produtosRelatoriosRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Produto.Incluir"
          )
        ) {
          var produtosAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/produtos/editar`,
          };

          var produtosAdicionarRotas = {
            path: "/:url/cadastros/produtos/editar",
            name: "cadastros/produtos/editar",
            component: () => import("@/views/produtos/Editar.vue"),
            meta: {
              pageTitle: "Produtos",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (produtosModulo !== null) {
            produtosModulo.sub.push(produtosAdicionarModulo);
          }

          rotas.push(produtosAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Produto.Alterar"
          )
        ) {
          var produtosTributacaoModulo = {
            heading: "Atualizar",
            route: `/${utils.getWL()}/cadastros/produtos/tributacao`,
          };

          var produtosTributacaoRotas = {
            path: "/:url/cadastros/produtos/tributacao",
            name: "cadastros/produtos/tributacao",
            component: () =>
              import("@/views/produtos/TributacaoAtualizacao.vue"),
            meta: {
              pageTitle: "Produtos",
              breadcrumbs: ["Atualizar"],
            },
          };

          if (produtosModulo !== null) {
            produtosModulo.sub.push(produtosTributacaoModulo);
          }

          rotas.push(produtosTributacaoRotas);

          var produtosEditarRotas = {
            path: "/:url/cadastros/produtos/editar/:id",
            name: "cadastros/produtos/editar/:id",
            component: () => import("@/views/produtos/Editar.vue"),
            meta: {
              pageTitle: "Produtos",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(produtosEditarRotas);
        }

        if (
          produtosModulo !== null &&
          tributaAiHabilitado &&
          (user.User.TipoUsuario.tipo === "Administrador" ||
            permissoesEmitente.find(
              (modulo) =>
                modulo.regra == "Permitir.TributaAI.Snapshot.Consultar"
            ))
        ) {
          produtosModulo.sub.push({
            heading: "Tributa AI",
            route: `/${utils.getWL()}/cadastros/produtos/tributa-ai`,
          });
        }

        if (
          produtosModulo !== null &&
          lojaVirtualHabilitada &&
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Produto.Alterar"
          )
        ) {
          produtosModulo.sub.push({
            heading: "Configurar loja online",
            route: `/${utils.getWL()}/cadastros/produtos/loja-online`,
          });
          produtosModulo.sub.push({
            heading: "Catálogo online",
            route: `/${utils.getWL()}/cadastros/produtos/catalogo-online`,
          });
        }

        if (
          produtosModulo !== null &&
          produtosModulo.sub.findIndex(
            (item) =>
              item.route ===
              `/${utils.getWL()}/cadastros/produtos/relatorios/consultar`
          ) === -1
        ) {
          produtosModulo.sub.push(produtosRelatoriosModulo);
        }
        //#endregion

        //#region Menu - Cadastros - Etiquetas
        if (user.User.Emitente.tipo_pacote > 1) {
          if (
            permissoesEmitente.find(
              (modulo) =>
                modulo.regra == "Permitir.LabelTemplate.Consultar" ||
                modulo.regra == "Permitir.LabelPrint.Gerenciar"
            )
          ) {
            let etiquetasSubMenus = [];

            if (
              permissoesEmitente.find(
                (modulo) => modulo.regra == "Permitir.LabelTemplate.Consultar"
              )
            ) {
              etiquetasSubMenus.push({
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/etiquetas/consultar`,
              });
            }

            if (
              permissoesEmitente.find(
                (modulo) => modulo.regra == "Permitir.LabelTemplate.Incluir"
              )
            ) {
              etiquetasSubMenus.push({
                heading: "Adicionar",
                route: `/${utils.getWL()}/cadastros/etiquetas/editar`,
              });
            }

            if (
              permissoesEmitente.find(
                (modulo) => modulo.regra == "Permitir.LabelPrint.Gerenciar"
              )
            ) {
              etiquetasSubMenus.push({
                heading: "Imprimir",
                route: `/${utils.getWL()}/cadastros/etiquetas/imprimir`,
              });
            }

            etiquetasModulo = {
              ordem: 3,
              sectionTitle: "Etiquetas",
              route: `/${utils.getWL()}/cadastros/etiquetas`,
              svgIcon: "media/icons/duotune/ecommerce/ecm010.svg",
              fontIcon: "bi-tag",
              sub: etiquetasSubMenus,
            };

            etiquetasRota = {
              path: "/:url/cadastros/etiquetas/consultar",
              name: "cadastros/etiquetas/consultar",
              component: () => import("@/views/etiquetas/Consultar.vue"),
              meta: {
                pageTitle: "Etiquetas",
                breadcrumbs: ["Consultar"],
              },
            };

            auxiliares.pages.push(etiquetasModulo);
            rotas.push(etiquetasRota);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.LabelTemplate.Incluir"
            )
          ) {
            var etiquetasAdicionarRota = {
              path: "/:url/cadastros/etiquetas/editar",
              name: "cadastros/etiquetas/editar",
              component: () => import("@/views/etiquetas/Editar.vue"),
              meta: {
                pageTitle: "Etiquetas",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(etiquetasAdicionarRota);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.LabelTemplate.Alterar"
            )
          ) {
            var etiquetasEditarRota = {
              path: "/:url/cadastros/etiquetas/editar/:id",
              name: "cadastros/etiquetas/editar/:id",
              component: () => import("@/views/etiquetas/Editar.vue"),
              meta: {
                pageTitle: "Etiquetas",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(etiquetasEditarRota);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.LabelPrint.Gerenciar"
            )
          ) {
            var etiquetasImprimirRota = {
              path: "/:url/cadastros/etiquetas/imprimir",
              name: "cadastros/etiquetas/imprimir",
              component: () => import("@/views/etiquetas/Imprimir.vue"),
              meta: {
                pageTitle: "Etiquetas",
                breadcrumbs: ["Imprimir"],
              },
            };

            rotas.push(etiquetasImprimirRota);
          }
        }
        //#endregion

        //#region Menu - Auxiliares - Balança
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Produto.Consultar"
          )
        ) {
          var balancaModulo = {
            ordem: 4,
            sectionTitle: "Gerador de Balança",
            route: `/${utils.getWL()}/auxiliares/balanca`,
            svgIcon: "media/icons/duotune/files/fil010.svg",
            fontIcon: "bi-upc-scan",
            sub: [
              {
                heading: "Gerar Arquivo",
                route: `/${utils.getWL()}/auxiliares/balanca`,
              },
            ],
          };

          var balancaRota = {
            path: "/:url/auxiliares/balanca",
            name: "auxiliares/balanca",
            component: () => import("@/views/balanca/Gerador.vue"),
            meta: {
              pageTitle: "Gerador de Arquivo de Balança",
              breadcrumbs: ["Auxiliares", "Balança"],
            },
          };

          auxiliares.pages.push(balancaModulo);
          rotas.push(balancaRota);
        }
        //#endregion

        //#region Menu - Cadastros - Transportadoras
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Transportadora.Consultar"
          )
        ) {
          transportadorasModulo = {
            ordem: 4,
            sectionTitle: "Transportadoras",
            route: `/${utils.getWL()}/cadastros/transportadoras`,
            svgIcon: "media/icons/duotune/ecommerce/ecm006.svg",
            fontIcon: "bi-truck",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/transportadoras/consultar`,
              },
            ],
          };

          transportadorasRota = {
            path: "/:url/cadastros/transportadoras/consultar",
            name: "cadastros/transportadoras/consultar",
            component: () => import("@/views/transportadoras/Consultar.vue"),
            meta: {
              pageTitle: "Transportadoras",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(transportadorasModulo);
          rotas.push(transportadorasRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Transportadora.Incluir"
          )
        ) {
          var transportadorasAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/transportadoras/editar`,
          };

          var transportadorasAdicionarRotas = {
            path: "/:url/cadastros/transportadoras/editar",
            name: "cadastros/transportadoras/editar",
            component: () => import("@/views/transportadoras/Editar.vue"),
            meta: {
              pageTitle: "Transportadoras",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (transportadorasModulo !== null) {
            transportadorasModulo.sub.push(transportadorasAdicionarModulo);
          }

          rotas.push(transportadorasAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Transportadora.Alterar"
          )
        ) {
          var transportadorasEditarRotas = {
            path: "/:url/cadastros/transportadoras/editar/:id",
            name: "cadastros/transportadoras/editar/:id",
            component: () => import("@/views/transportadoras/Editar.vue"),
            meta: {
              pageTitle: "Transportadoras",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(transportadorasEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Fornecedores
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Fornecedor.Consultar"
          )
        ) {
          fornecedoresModulo = {
            ordem: 5,
            sectionTitle: "Fornecedores",
            route: `/${utils.getWL()}/cadastros/fornecedores`,
            svgIcon: "media/icons/duotune/communication/com014.svg",
            fontIcon: "bi-people-fill",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/fornecedores/consultar`,
              },
            ],
          };

          fornecedoresRota = {
            path: "/:url/cadastros/fornecedores/consultar",
            name: "cadastros/fornecedores/consultar",
            component: () => import("@/views/fornecedores/Consultar.vue"),
            meta: {
              pageTitle: "Fornecedores",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(fornecedoresModulo);
          rotas.push(fornecedoresRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Fornecedor.Incluir"
          )
        ) {
          var fornecedoresAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/fornecedores/editar`,
          };

          var fornecedoresAdicionarRotas = {
            path: "/:url/cadastros/fornecedores/editar",
            name: "cadastros/fornecedores/editar",
            component: () => import("@/views/fornecedores/Editar.vue"),
            meta: {
              pageTitle: "Fornecedores",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (fornecedoresModulo !== null) {
            fornecedoresModulo.sub.push(fornecedoresAdicionarModulo);
          }

          rotas.push(fornecedoresAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Fornecedor.Alterar"
          )
        ) {
          var fornecedoresEditarRotas = {
            path: "/:url/cadastros/fornecedores/editar/:id",
            name: "cadastros/fornecedores/editar/:id",
            component: () => import("@/views/fornecedores/Editar.vue"),
            meta: {
              pageTitle: "Fornecedores",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(fornecedoresEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Vendedores
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Vendedor.Consultar"
          )
        ) {
          vendedoresModulo = {
            ordem: 6,
            sectionTitle: "Vendedores",
            route: `/${utils.getWL()}/cadastros/vendedores`,
            svgIcon: "media/icons/duotune/communication/com013.svg",
            fontIcon: "bi-person-fill",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/vendedores/consultar`,
              },
            ],
          };

          vendedoresRota = {
            path: "/:url/cadastros/vendedores/consultar",
            name: "cadastros/vendedores/consultar",
            component: () => import("@/views/vendedores/Consultar.vue"),
            meta: {
              pageTitle: "Vendedores",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(vendedoresModulo);
          rotas.push(vendedoresRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Vendedor.Incluir"
          )
        ) {
          var vendedoresAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/vendedores/editar`,
          };

          var vendedoresAdicionarRotas = {
            path: "/:url/cadastros/vendedores/editar",
            name: "cadastros/vendedores/editar",
            component: () => import("@/views/vendedores/Editar.vue"),
            meta: {
              pageTitle: "Vendedores",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (vendedoresModulo !== null) {
            vendedoresModulo.sub.push(vendedoresAdicionarModulo);
          }

          rotas.push(vendedoresAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Vendedor.Alterar"
          )
        ) {
          var vendedoresEditarRotas = {
            path: "/:url/cadastros/vendedores/editar/:id",
            name: "cadastros/vendedores/editar/:id",
            component: () => import("@/views/vendedores/Editar.vue"),
            meta: {
              pageTitle: "Vendedores",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(vendedoresEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Técnicos
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Tecnico.Consultar"
          )
        ) {
          tecnicosModulo = {
            ordem: 6.1,
            sectionTitle: "Técnicos",
            route: `/${utils.getWL()}/cadastros/tecnicos`,
            svgIcon: "media/icons/duotune/communication/com013.svg",
            fontIcon: "bi-person-badge",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/tecnicos/consultar`,
              },
            ],
          };

          tecnicosRota = {
            path: "/:url/cadastros/tecnicos/consultar",
            name: "cadastros/tecnicos/consultar",
            component: () => import("@/views/tecnicos/Consultar.vue"),
            meta: {
              pageTitle: "Técnicos",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(tecnicosModulo);
          rotas.push(tecnicosRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Tecnico.Incluir"
          )
        ) {
          var tecnicosAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/tecnicos/editar`,
          };

          var tecnicosAdicionarRotas = {
            path: "/:url/cadastros/tecnicos/editar",
            name: "cadastros/tecnicos/editar",
            component: () => import("@/views/tecnicos/Editar.vue"),
            meta: {
              pageTitle: "Técnicos",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (tecnicosModulo !== null) {
            tecnicosModulo.sub.push(tecnicosAdicionarModulo);
          }

          rotas.push(tecnicosAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Tecnico.Alterar"
          )
        ) {
          var tecnicosEditarRotas = {
            path: "/:url/cadastros/tecnicos/editar/:id",
            name: "cadastros/tecnicos/editar/:id",
            component: () => import("@/views/tecnicos/Editar.vue"),
            meta: {
              pageTitle: "Técnicos",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(tecnicosEditarRotas);
        }
        //#endregion

        //#region Menu - Cadastros - Motoristas
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Motorista.Consultar"
          )
        ) {
          motoristasModulo = {
            ordem: 7,
            sectionTitle: "Motoristas",
            route: `/${utils.getWL()}/cadastros/motoristas`,
            svgIcon: "media/icons/duotune/technology/teh002.svg",
            fontIcon: "bi-person-square",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/cadastros/motoristas/consultar`,
              },
            ],
          };

          motoristasRota = {
            path: "/:url/cadastros/motoristas/consultar",
            name: "cadastros/motoristas/consultar",
            component: () => import("@/views/motoristas/Consultar.vue"),
            meta: {
              pageTitle: "Motoristas",
              breadcrumbs: ["Consultar"],
            },
          };

          cadastros.pages.push(motoristasModulo);
          rotas.push(motoristasRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Motorista.Incluir"
          )
        ) {
          var motoristasAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/cadastros/motoristas/editar`,
          };

          var motoristasAdicionarRotas = {
            path: "/:url/cadastros/motoristas/editar",
            name: "cadastros/motoristas/editar",
            component: () => import("@/views/motoristas/Editar.vue"),
            meta: {
              pageTitle: "Motoristas",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (motoristasModulo !== null) {
            motoristasModulo.sub.push(motoristasAdicionarModulo);
          }

          rotas.push(motoristasAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Motorista.Alterar"
          )
        ) {
          var motoristasEditarRotas = {
            path: "/:url/cadastros/motoristas/editar/:id",
            name: "cadastros/motoristas/editar/:id",
            component: () => import("@/views/motoristas/Editar.vue"),
            meta: {
              pageTitle: "Motoristas",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(motoristasEditarRotas);
        }
        //#endregion

        //#endregion

        //#region Menu - Movimentação

        //#region Menu - Movimentação - Faturamento
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Faturamento.Consultar"
          )
        ) {
          faturamentoModulo = {
            ordem: 1,
            sectionTitle: "Faturamento",
            route: `/${utils.getWL()}/movimentacao/faturamento`,
            svgIcon: "media/icons/duotune/ecommerce/ecm008.svg",
            fontIcon: "bi-clipboard2-check",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/movimentacao/faturamento/consultar`,
              },
            ],
          };

          faturamentoRota = {
            path: "/:url/movimentacao/faturamento/consultar",
            name: "movimentacao/faturamento/consultar",
            component: () => import("@/views/faturamento/Consultar.vue"),
            meta: {
              pageTitle: "Faturamento",
              breadcrumbs: ["Consultar"],
            },
          };

          movimentacao.pages.push(faturamentoModulo);
          rotas.push(faturamentoRota);

          faturamentoModulo.sub.push({
            heading: "Relatórios",
            route: `/${utils.getWL()}/movimentacao/faturamento/relatorios/consultar`,
          });

          rotas.push({
            path: "/:url/movimentacao/faturamento/relatorios/consultar",
            name: "movimentacao/faturamento/relatorios/consultar",
            component: () =>
              import("@/views/faturamento/relatorios/Consultar.vue"),
            meta: {
              pageTitle: "Relatórios de Faturamento",
              breadcrumbs: ["Faturamento", "Relatórios"],
            },
          });

          faturamentoModulo.sub.push({
            heading: "Vendas Unificadas",
            route: `/${utils.getWL()}/movimentacao/faturamento/vendas-unificadas/consultar`,
          });

          rotas.push({
            path: "/:url/movimentacao/faturamento/vendas-unificadas/consultar",
            name: "movimentacao/faturamento/vendas-unificadas/consultar",
            component: () =>
              import("@/views/faturamento/vendas-unificadas/Consultar.vue"),
            meta: {
              pageTitle: "Vendas Unificadas",
              breadcrumbs: ["Faturamento", "Vendas Unificadas"],
            },
          });
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Faturamento.Incluir"
          )
        ) {
          var faturamentoAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/movimentacao/faturamento/editar`,
          };

          var faturamentoAdicionarRotas = {
            path: "/:url/movimentacao/faturamento/editar",
            name: "movimentacao/faturamento/editar",
            component: () => import("@/views/faturamento/Editar.vue"),
            meta: {
              pageTitle: "Faturamento",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (faturamentoModulo !== null) {
            faturamentoModulo.sub.push(faturamentoAdicionarModulo);
          }

          rotas.push(faturamentoAdicionarRotas);
        }

        const faturamentoRelatoriosRoute = `/${utils.getWL()}/movimentacao/faturamento/relatorios/consultar`;
        const faturamentoVendasUnificadasRoute = `/${utils.getWL()}/movimentacao/faturamento/vendas-unificadas/consultar`;
        const possuiPermissaoRelatoriosFaturamento = permissoesEmitente.find(
          (modulo) => modulo.regra == "Permitir.Faturamento.Consultar"
        );

        if (faturamentoModulo !== null) {
          faturamentoModulo.sub = faturamentoModulo.sub.filter((item) => {
            if (
              (item.route === faturamentoRelatoriosRoute ||
                item.route === faturamentoVendasUnificadasRoute) &&
              !possuiPermissaoRelatoriosFaturamento
            ) {
              return false;
            }

            return true;
          });

          if (possuiPermissaoRelatoriosFaturamento) {
            const consultarItens = faturamentoModulo.sub.filter(
              (item) =>
                item.route !== faturamentoRelatoriosRoute &&
                item.route !== faturamentoVendasUnificadasRoute &&
                item.heading !== "Adicionar"
            );
            const adicionarItens = faturamentoModulo.sub.filter(
              (item) => item.heading === "Adicionar"
            );
            const relatorioItens = faturamentoModulo.sub.filter(
              (item) => item.route === faturamentoRelatoriosRoute
            );
            const vendasUnificadasItens = faturamentoModulo.sub.filter(
              (item) => item.route === faturamentoVendasUnificadasRoute
            );

            faturamentoModulo.sub = [
              ...consultarItens,
              ...adicionarItens,
              ...relatorioItens,
              ...vendasUnificadasItens,
            ];
          }
        }

        if (!possuiPermissaoRelatoriosFaturamento) {
          rotas = rotas.filter(
            (item) =>
              item.name !== "movimentacao/faturamento/relatorios/consultar" &&
              item.name !==
                "movimentacao/faturamento/vendas-unificadas/consultar"
          );
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Faturamento.Alterar"
          )
        ) {
          var faturamentoEditarRotas = {
            path: "/:url/movimentacao/faturamento/editar/:id",
            name: "movimentacao/faturamento/editar/:id",
            component: () => import("@/views/faturamento/Editar.vue"),
            meta: {
              pageTitle: "Faturamento",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(faturamentoEditarRotas);
        }
        //#endregion

        //#region Menu - Movimentação - CTe
        if (
          permissoesEmitente.find(
            (modulo) =>
              modulo.regra == "Permitir.GerenciadorCTe.Consultar" ||
              modulo.regra == "Permitir.Faturamento.Consultar"
          )
        ) {
          cteModulo = {
            ordem: 3,
            sectionTitle: "CT-e",
            route: `/${utils.getWL()}/movimentacao/cte`,
            svgIcon: "media/icons/duotune/ecommerce/ecm006.svg",
            fontIcon: "bi-truck",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/movimentacao/cte/consultar`,
              },
            ],
          };

          cteRota = {
            path: "/:url/movimentacao/cte/consultar",
            name: "movimentacao/cte/consultar",
            component: () => import("@/views/cte/Consultar.vue"),
            meta: {
              pageTitle: "CT-e",
              breadcrumbs: ["Consultar"],
            },
          };

          movimentacao.pages.push(cteModulo);
          rotas.push(cteRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) =>
              modulo.regra == "Permitir.GerenciadorCTe.Incluir" ||
              modulo.regra == "Permitir.Faturamento.Incluir"
          )
        ) {
          var cteAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/movimentacao/cte/editar`,
          };

          var cteAdicionarRotas = {
            path: "/:url/movimentacao/cte/editar",
            name: "movimentacao/cte/editar",
            component: () => import("@/views/cte/Editar.vue"),
            meta: {
              pageTitle: "CT-e",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (cteModulo !== null) {
            cteModulo.sub.push(cteAdicionarModulo);
          }

          rotas.push(cteAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) =>
              modulo.regra == "Permitir.GerenciadorCTe.Alterar" ||
              modulo.regra == "Permitir.Faturamento.Alterar"
          )
        ) {
          var cteEditarRotas = {
            path: "/:url/movimentacao/cte/editar/:id",
            name: "movimentacao/cte/editar/:id",
            component: () => import("@/views/cte/Editar.vue"),
            meta: {
              pageTitle: "CT-e",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(cteEditarRotas);
        }
        //#endregion

        //#region Menu - Movimentação - NFSe
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Faturamento.Consultar"
          )
        ) {
          nfseModulo = {
            ordem: 2,
            sectionTitle: "NFSe",
            route: `/${utils.getWL()}/movimentacao/nfse`,
            svgIcon: "media/icons/duotune/maps/map004.svg",
            fontIcon: "bi-receipt",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/movimentacao/nfse/consultar`,
              },
            ],
          };

          nfseRota = {
            path: "/:url/movimentacao/nfse/consultar",
            name: "movimentacao/nfse/consultar",
            component: () => import("@/views/nfse/Consultar.vue"),
            meta: {
              pageTitle: "NFSe",
              breadcrumbs: ["Consultar"],
            },
          };

          movimentacao.pages.push(nfseModulo);
          rotas.push(nfseRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Faturamento.Incluir"
          )
        ) {
          var nfseAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/movimentacao/nfse/editar`,
          };

          var nfseAdicionarRotas = {
            path: "/:url/movimentacao/nfse/editar",
            name: "movimentacao/nfse/editar",
            component: () => import("@/views/nfse/Editar.vue"),
            meta: {
              pageTitle: "NFSe",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (nfseModulo !== null) {
            nfseModulo.sub.push(nfseAdicionarModulo);
          }

          rotas.push(nfseAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Faturamento.Alterar"
          )
        ) {
          var nfseEditarRotas = {
            path: "/:url/movimentacao/nfse/editar/:id",
            name: "movimentacao/nfse/editar/:id",
            component: () => import("@/views/nfse/Editar.vue"),
            meta: {
              pageTitle: "NFSe",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(nfseEditarRotas);
        }
        //#endregion

        //#region Menu - Movimentação - Gerenciar NF-e
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFe.Consultar"
          )
        ) {
          gerenciadorNFeModulo = {
            ordem: 4,
            sectionTitle: "Gerenciar NF-e",
            route: `/${utils.getWL()}/movimentacao/gerenciarNFe`,
            svgIcon: "media/icons/duotune/abstract/abs007.svg",
            fontIcon: "bi-clipboard2-check",
            sub: [
              {
                heading: "Gerenciar",
                route: `/${utils.getWL()}/movimentacao/gerenciarNFe/gerenciarnfe`,
              },
            ],
          };

          gerenciadorNFeRota = {
            path: "/:url/movimentacao/gerenciarNFe/gerenciarnfe",
            name: "movimentacao/gerenciarNFe/gerenciarnfe",
            component: () => import("@/views/gerenciarnfe/GerenciarNFe.vue"),
            meta: {
              pageTitle: "Gerenciar NF-e",
              breadcrumbs: ["Gerenciar NF-e"],
            },
          };

          movimentacao.pages.push(gerenciadorNFeModulo);
          rotas.push(gerenciadorNFeRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFe.Inutilizar"
          )
        ) {
          let gerenciadorNFeInutilizacoesModulo = {
            heading: "Inutilizações",
            route: `/${utils.getWL()}/movimentacao/gerenciarNFe/inutilizacaonfe`,
          };

          let gerencaidorNFeInutilizacaoRotas = {
            path: "/:url/movimentacao/gerenciarNFe/inutilizacaonfe",
            name: "movimentacao/gerenciarNFe/inutilizacaonfe",
            component: () => import("@/views/gerenciarnfe/InutilizacaoNFe.vue"),
            meta: {
              pageTitle: "Inutilização NF-e",
              breadcrumbs: ["Gerenciar NF-e", "Inutilização"],
            },
          };

          if (gerenciadorNFeModulo !== null) {
            gerenciadorNFeModulo.sub.push(gerenciadorNFeInutilizacoesModulo);
          }

          rotas.push(gerencaidorNFeInutilizacaoRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFe.CartaCorrecao"
          )
        ) {
          let gerenciadorNFeCartaCorrecaoModulo = {
            heading: "Carta de Correção",
            route: `/${utils.getWL()}/movimentacao/gerenciarNFe/cartacorrecaonfe`,
          };

          let gerencaidorNFeCartaCorrecaoRotas = {
            path: "/:url/movimentacao/gerenciarNFe/cartacorrecaonfe",
            name: "movimentacao/gerenciarNFe/cartacorrecaonfe",
            component: () =>
              import("@/views/gerenciarnfe/CartaCorrecaoNFe.vue"),
            meta: {
              pageTitle: "Carta de Correção NF-e",
              breadcrumbs: ["Gerenciar NF-e", "Carta de Correção"],
            },
          };

          if (gerenciadorNFeModulo !== null) {
            gerenciadorNFeModulo.sub.push(gerenciadorNFeCartaCorrecaoModulo);
          }

          rotas.push(gerencaidorNFeCartaCorrecaoRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFe.ArquivosXML"
          )
        ) {
          let auxiliaresArquivosXmlModulo = {
            ordem: 5,
            sectionTitle: "Arquivos XML",
            route: `/${utils.getWL()}/movimentacao/gerenciarNFe/arquivosxml`,
            svgIcon: "media/icons/duotune/coding/cod003.svg",
            fontIcon: "bi-filetype-xml",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/movimentacao/gerenciarNFe/arquivosxml`,
              },
            ],
          };

          let gerenciadorNFeArquivosModulo = {
            heading: "Arquivos XML",
            route: `/${utils.getWL()}/movimentacao/gerenciarNFe/arquivosxml`,
          };

          let gerencaidorNFeArquivosRotas = {
            path: "/:url/movimentacao/gerenciarNFe/arquivosxml",
            name: "movimentacao/gerenciarNFe/arquivosxml",
            component: () => import("@/views/gerenciarnfe/ArquivosXMLNFe.vue"),
            meta: {
              pageTitle: "Arquivos XML",
              breadcrumbs: ["Gerenciar NF-e", "Arquivos XML"],
            },
          };

          if (gerenciadorNFeModulo !== null) {
            gerenciadorNFeModulo.sub.push(gerenciadorNFeArquivosModulo);
          }

          auxiliares.pages.push(auxiliaresArquivosXmlModulo);
          rotas.push(gerencaidorNFeArquivosRotas);
        }
        //#endregion

        //#region Menu - Movimentação - PDV
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Consultar"
          )
        ) {
          pdvModulo = {
            ordem: 5,
            sectionTitle: "Frente de Caixa",
            route: `/${utils.getWL()}/movimentacao/pdv`,
            svgIcon: "media/icons/duotune/ecommerce/ecm001.svg",
            fontIcon: "bi-clipboard2-check",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/movimentacao/pdv/consultar`,
              },
            ],
          };

          pdvRota = {
            path: "/:url/movimentacao/pdv/consultar",
            name: "movimentacao/pdv/consultar",
            component: () => import("@/views/pdv/Consultar.vue"),
            meta: {
              pageTitle: "Frente de Caixa",
              breadcrumbs: ["Consultar"],
            },
          };

          movimentacao.pages.push(pdvModulo);
          rotas.push(pdvRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Incluir"
          )
        ) {
          var pdvIncluirVendaModulo = {
            heading: "Venda",
            route: `/${utils.getWL()}/movimentacao/pdv/venda`,
          };

          var pdvIncluirVendaRotas = {
            path: "/:url/movimentacao/pdv/venda",
            name: "movimentacao/pdv/venda",
            component: () => import("@/views/pdv/Venda.vue"),
            meta: {
              pageTitle: "Frente de Caixa",
              breadcrumbs: ["Consultar", "Venda"],
            },
          };

          if (pdvModulo !== null) {
            pdvModulo.sub.push(pdvIncluirVendaModulo);
          }

          rotas.push(pdvIncluirVendaRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Troca"
          )
        ) {
          let pdvTrocasModulo = {
            heading: "Trocas",
            route: `/${utils.getWL()}/movimentacao/pdv/trocas`,
          };

          let pdvTrocasRotas = {
            path: "/:url/movimentacao/pdv/trocas",
            name: "movimentacao/pdv/trocas",
            component: () => import("@/views/pdv/trocas/Consultar.vue"),
            meta: {
              pageTitle: "Trocas e Créditos",
              breadcrumbs: ["Frente de Caixa", "Trocas"],
            },
          };

          if (pdvModulo !== null) {
            pdvModulo.sub.push(pdvTrocasModulo);
          }

          rotas.push(pdvTrocasRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Consultar"
          )
        ) {
          let pdvFinalizadorasModulo = {
            heading: "Finalizadoras",
            route: `/${utils.getWL()}/movimentacao/pdv/finalizadoras`,
          };

          let pdvFinalizadorasRotas = {
            path: "/:url/movimentacao/pdv/finalizadoras",
            name: "movimentacao/pdv/finalizadoras",
            component: () => import("@/views/pdv/finalizadoras/Consultar.vue"),
            meta: {
              pageTitle: "Finalizadoras do PDV",
              breadcrumbs: ["Frente de Caixa", "Finalizadoras"],
            },
          };

          if (pdvModulo !== null) {
            pdvModulo.sub.push(pdvFinalizadorasModulo);
          }

          rotas.push(pdvFinalizadorasRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Consultar"
          )
        ) {
          let pdvAtualizacoesModulo = {
            heading: "Atualizações",
            route: `/${utils.getWL()}/movimentacao/pdv/atualizacoes`,
          };

          let pdvAtualizacoesRotas = {
            path: "/:url/movimentacao/pdv/atualizacoes",
            name: "movimentacao/pdv/atualizacoes",
            component: () => import("@/views/pdv/atualizacoes/Consultar.vue"),
            meta: {
              pageTitle: "Atualizações do PDV",
              breadcrumbs: ["Frente de Caixa", "Atualizações"],
            },
          };

          void pdvAtualizacoesModulo;

          if (pdvModulo !== null) {
            // Mantém a rota por compatibilidade, mas sem expor no menu operacional do PDV.
          }

          rotas.push(pdvAtualizacoesRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Consultar"
          )
        ) {
          let pdvTerminaisModulo = {
            heading: "Terminais",
            route: `/${utils.getWL()}/movimentacao/pdv/terminais`,
          };

          let pdvTerminaisRotas = {
            path: "/:url/movimentacao/pdv/terminais",
            name: "movimentacao/pdv/terminais",
            component: () => import("@/views/pdv/terminais/Consultar.vue"),
            meta: {
              pageTitle: "Terminais PDV",
              breadcrumbs: ["Frente de Caixa", "Terminais"],
            },
          };

          if (pdvModulo !== null) {
            pdvModulo.sub.push(pdvTerminaisModulo);
          }

          rotas.push(pdvTerminaisRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Alterar"
          )
        ) {
          var pdvEditarVendaRotas = {
            path: "/:url/movimentacao/pdv/venda/:id",
            name: "movimentacao/pdv/venda/:id",
            component: () => import("@/views/pdv/Venda.vue"),
            meta: {
              pageTitle: "Frente de Caixa",
              breadcrumbs: ["Consultar", "Venda"],
            },
          };

          rotas.push(pdvEditarVendaRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.GerenciadorNFCe.Inutilizar"
          )
        ) {
          let pdvInutilizacoesModulo = {
            heading: "Inutilizações",
            route: `/${utils.getWL()}/movimentacao/pdv/inutilizacaonfce`,
          };

          let pdvInutilizacaoRotas = {
            path: "/:url/movimentacao/pdv/inutilizacaonfce",
            name: "movimentacao/pdv/inutilizacaonfce",
            component: () => import("@/views/pdv/InutilizacaoNFCe.vue"),
            meta: {
              pageTitle: "Inutilização NFC-e",
              breadcrumbs: ["Consultar", "Inutilização"],
            },
          };

          if (pdvModulo !== null) {
            pdvModulo.sub.push(pdvInutilizacoesModulo);
          }

          rotas.push(pdvInutilizacaoRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.VendasCupom.Consultar"
          )
        ) {
          let pdvRelatoriosModulo = {
            heading: "Relatórios",
            route: `/${utils.getWL()}/movimentacao/pdv/relatorios/consultar`,
          };

          let pdvRelatoriosRotas = {
            path: "/:url/movimentacao/pdv/relatorios/consultar",
            name: "movimentacao/pdv/relatorios/consultar",
            component: () => import("@/views/pdv/relatorios/Consultar.vue"),
            meta: {
              pageTitle: "Relatórios de PDV",
              breadcrumbs: ["Frente de Caixa", "Relatórios"],
            },
          };

          if (pdvModulo !== null) {
            pdvModulo.sub.push(pdvRelatoriosModulo);
          }

          rotas.push(pdvRelatoriosRotas);
        }
        //#endregion

        //#region Menu - Movimentação - Pedidos
        if (user.User.Emitente.tipo_pacote > 1) {
          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pedido.Consultar"
            )
          ) {
            pedidosModulo = {
              ordem: 6,
              sectionTitle: "Pedidos",
              route: `/${utils.getWL()}/movimentacao/pedidos`,
              svgIcon: "media/icons/duotune/ecommerce/ecm002.svg",
              fontIcon: "bi-basket2",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/movimentacao/pedidos/consultar`,
                },
              ],
            };

            pedidosRota = {
              path: "/:url/movimentacao/pedidos/consultar",
              name: "movimentacao/pedidos/consultar",
              component: () => import("@/views/pedidos/Consultar.vue"),
              meta: {
                pageTitle: "Pedidos",
                breadcrumbs: ["Consultar"],
              },
            };

            movimentacao.pages.push(pedidosModulo);
            rotas.push(pedidosRota);

            if (lojaVirtualHabilitada) {
              pedidosModulo.sub.push({
                heading: "Pedidos online",
                route: `/${utils.getWL()}/movimentacao/pedidos/online`,
              });
              rotas.push({
                path: "/:url/movimentacao/pedidos/online",
                name: "movimentacao/pedidos/online",
                component: () => import("@/views/pedidos/PedidosOnline.vue"),
                meta: {
                  pageTitle: "Pedidos online",
                  breadcrumbs: ["Pedidos", "Loja online"],
                },
              });
            }

            rotas.push({
              path: "/:url/movimentacao/pedidos/kds",
              name: "movimentacao/pedidos/kds",
              component: () => import("@/views/pedidos/Kds.vue"),
              meta: {
                pageTitle: "KDS de Pedidos",
                breadcrumbs: ["Pedidos", "KDS"],
              },
            });

            var pedidosRelatoriosModulo = {
              heading: "Relatorios",
              route: `/${utils.getWL()}/movimentacao/pedidos/relatorios/consultar`,
            };

            let pedidosRelatoriosRota = {
              path: "/:url/movimentacao/pedidos/relatorios/consultar",
              name: "movimentacao/pedidos/relatorios/consultar",
              component: () =>
                import("@/views/pedidos/relatorios/Consultar.vue"),
              meta: {
                pageTitle: "Relatorios de Pedidos",
                breadcrumbs: ["Pedidos", "Relatorios"],
              },
            };

            rotas.push(pedidosRelatoriosRota);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pedido.Incluir"
            )
          ) {
            var pedidosAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/movimentacao/pedidos/editar`,
            };

            var pedidosAdicionarRotas = {
              path: "/:url/movimentacao/pedidos/editar",
              name: "movimentacao/pedidos/editar",
              component: () => import("@/views/pedidos/Editar.vue"),
              meta: {
                pageTitle: "Pedidos",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (pedidosModulo !== null) {
              pedidosModulo.sub.push(pedidosAdicionarModulo);
            }

            rotas.push(pedidosAdicionarRotas);
          }

          if (pedidosModulo !== null) {
            pedidosModulo.sub.push({
              heading: "KDS",
              route: `/${utils.getWL()}/movimentacao/pedidos/kds`,
            });
            pedidosModulo.sub.push(pedidosRelatoriosModulo);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pedido.Alterar"
            )
          ) {
            var pedidosEditarRotas = {
              path: "/:url/movimentacao/pedidos/editar/:id",
              name: "movimentacao/pedidos/editar/:id",
              component: () => import("@/views/pedidos/Editar.vue"),
              meta: {
                pageTitle: "Pedidos",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(pedidosEditarRotas);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.OrdemServico.Consultar"
            )
          ) {
            ordensServicoModulo = {
              ordem: 6.1,
              sectionTitle: "Ordem de Serviço",
              route: `/${utils.getWL()}/movimentacao/ordemservico`,
              svgIcon: "media/icons/duotune/general/gen049.svg",
              fontIcon: "bi-tools",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/movimentacao/ordemservico/consultar`,
                },
              ],
            };

            ordensServicoRota = {
              path: "/:url/movimentacao/ordemservico/consultar",
              name: "movimentacao/ordemservico/consultar",
              component: () => import("@/views/ordemservico/Consultar.vue"),
              meta: {
                pageTitle: "Ordem de Serviço",
                breadcrumbs: ["Consultar"],
              },
            };

            movimentacao.pages.push(ordensServicoModulo);
            rotas.push(ordensServicoRota);

            let ordensServicoRelatoriosModulo = {
              heading: "Relatórios",
              route: `/${utils.getWL()}/movimentacao/ordemservico/relatorios/consultar`,
            };

            let ordensServicoRelatoriosRota = {
              path: "/:url/movimentacao/ordemservico/relatorios/consultar",
              name: "movimentacao/ordemservico/relatorios/consultar",
              component: () =>
                import("@/views/ordemservico/relatorios/Consultar.vue"),
              meta: {
                pageTitle: "Relatórios de Ordem de Serviço",
                breadcrumbs: ["Ordem de Serviço", "Relatórios"],
              },
            };

            ordensServicoModulo.sub.push(ordensServicoRelatoriosModulo);
            rotas.push(ordensServicoRelatoriosRota);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.OrdemServico.Incluir"
            )
          ) {
            var ordensServicoAdicionarModulo = {
              heading: "Adicionar",
              route: `/${utils.getWL()}/movimentacao/ordemservico/editar`,
            };

            var ordensServicoAdicionarRotas = {
              path: "/:url/movimentacao/ordemservico/editar",
              name: "movimentacao/ordemservico/editar",
              component: () => import("@/views/ordemservico/Editar.vue"),
              meta: {
                pageTitle: "Ordem de Serviço",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            if (ordensServicoModulo !== null) {
              ordensServicoModulo.sub.push(ordensServicoAdicionarModulo);
            }

            rotas.push(ordensServicoAdicionarRotas);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.OrdemServico.Alterar"
            )
          ) {
            var ordensServicoEditarRotas = {
              path: "/:url/movimentacao/ordemservico/editar/:id",
              name: "movimentacao/ordemservico/editar/:id",
              component: () => import("@/views/ordemservico/Editar.vue"),
              meta: {
                pageTitle: "Ordem de Serviço",
                breadcrumbs: ["Consultar", "Editar"],
              },
            };

            rotas.push(ordensServicoEditarRotas);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.OrdemServico.Consultar"
            )
          ) {
            agendamentosModulo = {
              ordem: 6.2,
              sectionTitle: "Agendamentos",
              route: `/${utils.getWL()}/movimentacao/agendamentos`,
              svgIcon: "media/icons/duotune/general/gen014.svg",
              fontIcon: "bi-calendar-week",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/movimentacao/agendamentos/consultar`,
                },
              ],
            };

            agendamentosRota = {
              path: "/:url/movimentacao/agendamentos/consultar",
              name: "movimentacao/agendamentos/consultar",
              component: () => import("@/views/agendamentos/Consultar.vue"),
              meta: {
                pageTitle: "Agendamentos",
                breadcrumbs: ["Consultar"],
              },
            };

            movimentacao.pages.push(agendamentosModulo);
            rotas.push(agendamentosRota);

            let agendamentosRelatoriosModulo = {
              heading: "Relatorios",
              route: `/${utils.getWL()}/movimentacao/agendamentos/relatorios/consultar`,
            };

            let agendamentosRelatoriosRota = {
              path: "/:url/movimentacao/agendamentos/relatorios/consultar",
              name: "movimentacao/agendamentos/relatorios/consultar",
              component: () =>
                import("@/views/agendamentos/relatorios/Consultar.vue"),
              meta: {
                pageTitle: "Relatorios de Agendamentos",
                breadcrumbs: ["Agendamentos", "Relatorios"],
              },
            };

            agendamentosModulo.sub.push(agendamentosRelatoriosModulo);
            rotas.push(agendamentosRelatoriosRota);
          }
        }
        //#endregion

        //#region Menu - Movimentação - Restaurante
        var exbirRestaurante =
          user.User.Emitente.ramo === "2" &&
          user.User.TipoUsuario.tipo === "Administrador";
        if (exbirRestaurante) {
          const podeMenuMesas = permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Restaurante.MenuMesas"
          );
          const podeMenuComandas = permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Restaurante.MenuComandas"
          );
          const podeMenuEntregas = permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Restaurante.MenuEntregas"
          );
          const podeMenuPedidos = permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Restaurante.MenuPedidos"
          );
          const podeMenuConfiguracoes = permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Restaurante.MenuConfiguracoes"
          );
          const podeMenuGarcons = podeMenuMesas;
          const podeMenuMotoristas = permissoesEmitente.find(
            (modulo) =>
              modulo.regra == "Permitir.RestauranteMotorista.Consultar"
          );
          const podeIncluirMotorista = permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.RestauranteMotorista.Incluir"
          );
          const podeAlterarMotorista = permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.RestauranteMotorista.Alterar"
          );
          if (
            podeMenuMesas ||
            podeMenuComandas ||
            podeMenuEntregas ||
            podeMenuPedidos ||
            podeMenuGarcons ||
            podeMenuMotoristas ||
            podeMenuConfiguracoes
          ) {
            const restauranteSub = [];

            if (podeMenuMesas) {
              restauranteSub.push({
                heading: "Mesas",
                route: `/${utils.getWL()}/restaurante/mesas`,
                activeRoutes: [`/${utils.getWL()}/restaurante/mesas`],
              });
            }

            if (podeMenuComandas) {
              restauranteSub.push({
                heading: "Comandas",
                route: `/${utils.getWL()}/restaurante/comandas`,
                activeRoutes: [`/${utils.getWL()}/restaurante/comandas`],
              });
            }

            if (podeMenuEntregas) {
              restauranteSub.push({
                heading: "Entregas",
                route: `/${utils.getWL()}/restaurante/entregas`,
                activeRoutes: [`/${utils.getWL()}/restaurante/entregas`],
              });
            }

            if (podeMenuPedidos) {
              restauranteSub.push({
                heading: "Pedidos",
                route: `/${utils.getWL()}/restaurante/pedidos`,
                activeRoutes: [`/${utils.getWL()}/restaurante/pedidos`],
              });
            }

            if (podeMenuGarcons) {
              restauranteSub.push({
                heading: "Garçons",
                route: `/${utils.getWL()}/restaurante/garcons`,
                activeRoutes: [`/${utils.getWL()}/restaurante/garcons`],
              });
            }

            if (podeMenuMotoristas) {
              restauranteSub.push({
                heading: "Entregadores",
                route: `/${utils.getWL()}/restaurante/motoristas`,
                activeRoutes: [`/${utils.getWL()}/restaurante/motoristas`],
              });
            }

            if (podeMenuConfiguracoes) {
              restauranteSub.push({
                heading: "Configurações",
                route: `/${utils.getWL()}/restaurante/configuracoes`,
                activeRoutes: [`/${utils.getWL()}/restaurante/configuracoes`],
              });
            }

            restauranteModulo = {
              ordem: 5,
              sectionTitle: "Restaurante",
              route: restauranteSub[0].route,
              activeRoutes: [`/${utils.getWL()}/restaurante/`],
              svgIcon: "media/icons/duotune/ecommerce/ecm004.svg",
              fontIcon: "bi-grid",
              sub: restauranteSub,
            };

            movimentacao.pages.push(restauranteModulo);
            if (podeMenuMesas) {
              rotas.push({
                path: "/:url/restaurante/mesas",
                name: "restaurante/mesas",
                component: () => import("@/views/restaurante/Mesas.vue"),
                meta: {
                  pageTitle: "Mesas",
                  breadcrumbs: ["Restaurante", "Mesas"],
                },
              });
            }
            if (podeMenuComandas) {
              rotas.push({
                path: "/:url/restaurante/comandas",
                name: "restaurante/comandas",
                component: () => import("@/views/restaurante/Comandas.vue"),
                meta: {
                  pageTitle: "Comandas",
                  breadcrumbs: ["Restaurante", "Comandas"],
                },
              });
            }
            if (podeMenuEntregas) {
              rotas.push({
                path: "/:url/restaurante/entregas",
                name: "restaurante/entregas",
                component: () => import("@/views/restaurante/Entregas.vue"),
                meta: {
                  pageTitle: "Entregas",
                  breadcrumbs: ["Restaurante", "Entregas"],
                },
              });
            }
            if (podeMenuPedidos) {
              rotas.push({
                path: "/:url/restaurante/pedidos",
                name: "restaurante/pedidos",
                component: () => import("@/views/restaurante/Pedidos.vue"),
                meta: {
                  pageTitle: "Pedidos",
                  breadcrumbs: ["Restaurante", "Pedidos"],
                },
              });
            }
            if (podeMenuGarcons) {
              rotas.push({
                path: "/:url/restaurante/garcons",
                name: "restaurante/garcons",
                component: () => import("@/views/restaurante/Garcons.vue"),
                meta: {
                  pageTitle: "Garçons",
                  breadcrumbs: ["Restaurante", "Garçons"],
                },
              });
              rotas.push({
                path: "/:url/restaurante/garcons/editar",
                name: "restaurante/garcons/editar",
                component: () => import("@/views/restaurante/GarconEditar.vue"),
                meta: {
                  pageTitle: "Adicionar garçom",
                  breadcrumbs: ["Restaurante", "Garçons", "Adicionar"],
                },
              });
              rotas.push({
                path: "/:url/restaurante/garcons/editar/:id",
                name: "restaurante/garcons/editar/:id",
                component: () => import("@/views/restaurante/GarconEditar.vue"),
                meta: {
                  pageTitle: "Editar garçom",
                  breadcrumbs: ["Restaurante", "Garçons", "Editar"],
                },
              });
            }
            if (podeMenuMotoristas) {
              rotas.push({
                path: "/:url/restaurante/motoristas",
                name: "restaurante/motoristas",
                component: () =>
                  import("@/views/restaurante/RestauranteMotoristas.vue"),
                meta: {
                  pageTitle: "Entregadores",
                  breadcrumbs: ["Restaurante", "Entregadores"],
                },
              });
              if (podeIncluirMotorista) {
                rotas.push({
                  path: "/:url/restaurante/motoristas/editar",
                  name: "restaurante/motoristas/editar",
                  component: () =>
                    import(
                      "@/views/restaurante/RestauranteMotoristaEditar.vue"
                    ),
                  meta: {
                    pageTitle: "Adicionar entregador",
                    breadcrumbs: ["Restaurante", "Entregadores", "Adicionar"],
                  },
                });
              }
              if (podeAlterarMotorista) {
                rotas.push({
                  path: "/:url/restaurante/motoristas/editar/:id",
                  name: "restaurante/motoristas/editar/:id",
                  component: () =>
                    import(
                      "@/views/restaurante/RestauranteMotoristaEditar.vue"
                    ),
                  meta: {
                    pageTitle: "Editar entregador",
                    breadcrumbs: ["Restaurante", "Entregadores", "Editar"],
                  },
                });
              }
            }
            if (podeMenuConfiguracoes) {
              rotas.push({
                path: "/:url/restaurante/configuracoes",
                name: "restaurante/configuracoes",
                component: () => import("@/views/configuracoes/Gerenciar.vue"),
                meta: {
                  pageTitle: "Configurações do Restaurante",
                  breadcrumbs: ["Restaurante", "Configurações"],
                },
              });
            }
          }
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Compra.Consultar"
          )
        ) {
          compraModulo = {
            ordem: 3,
            sectionTitle: "Compras",
            route: `/${utils.getWL()}/movimentacao/compra`,
            svgIcon: "media/icons/duotune/ecommerce/ecm009.svg",
            fontIcon: "bi-clipboard2-check",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/movimentacao/compra/consultar`,
              },
            ],
          };

          compraRota = {
            path: "/:url/movimentacao/compra/consultar",
            name: "movimentacao/compra/consultar",
            component: () => import("@/views/compra/Consultar.vue"),
            meta: {
              pageTitle: "Compras",
              breadcrumbs: ["Consultar"],
            },
          };

          movimentacao.pages.push(compraModulo);
          rotas.push(compraRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Compra.Incluir"
          )
        ) {
          var compraAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/movimentacao/compra/editar`,
          };

          var compraAdicionarRotas = {
            path: "/:url/movimentacao/compra/editar",
            name: "movimentacao/compra/editar",
            component: () => import("@/views/compra/Editar.vue"),
            meta: {
              pageTitle: "Compras",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (compraModulo !== null) {
            compraModulo.sub.push(compraAdicionarModulo);
          }

          rotas.push(compraAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Compra.Alterar"
          )
        ) {
          var compraEditarRotas = {
            path: "/:url/movimentacao/compra/editar/:id",
            name: "movimentacao/compra/editar/:id",
            component: () => import("@/views/compra/Editar.vue"),
            meta: {
              pageTitle: "Compras",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(compraEditarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.ManifestoDFe.Consultar"
          )
        ) {
          let consultaManifestoDFeModulo = {
            heading: "Manifesto DF-e",
            route: `/${utils.getWL()}/movimentacao/compra/manifestodfe`,
          };

          let consultaManifestoDFeRota = {
            path: "/:url/movimentacao/compra/manifestodfe",
            name: "movimentacao/compra/manifestodfe",
            component: () => import("@/views/compra/ConsultaManifestoDFe.vue"),
            meta: {
              pageTitle: "Manifesto DF-e",
              breadcrumbs: ["Compras", "Manifesto DF-e"],
            },
          };

          if (compraModulo !== null) {
            compraModulo.sub.push(consultaManifestoDFeModulo);
          }
          rotas.push(consultaManifestoDFeRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Compra.Relatorios"
          )
        ) {
          let compraRelatoriosModulo = {
            heading: "Relatórios",
            route: `/${utils.getWL()}/movimentacao/compra/relatorios/consultar`,
          };

          let compraRelatoriosRota = {
            path: "/:url/movimentacao/compra/relatorios/consultar",
            name: "movimentacao/compra/relatorios/consultar",
            component: () => import("@/views/compra/relatorios/Consultar.vue"),
            meta: {
              pageTitle: "Relatórios de Compras",
              breadcrumbs: ["Compras", "Relatórios"],
            },
          };

          if (compraModulo !== null) {
            compraModulo.sub.push(compraRelatoriosModulo);
          }
          rotas.push(compraRelatoriosRota);
        }

        //#endregion

        //#endregion

        //#region Menu - Financeiro

        //#region Menu - Financeiro - Dashboard
        const possuiPermissaoDashboardFinanceiro = permissoesEmitente.find(
          (modulo) => modulo.regra == "Permitir.DashboardFinanceiro.Consultar"
        );
        const possuiPermissaoFluxoCaixa = permissoesEmitente.find(
          (modulo) => modulo.regra == "Permitir.FluxoCaixa.Consultar"
        );
        const possuiPermissaoConciliacaoBancaria =
          isAdministradorGeral ||
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.ConciliacaoBancaria.Consultar"
          );
        const possuiAcessoPacoteConciliacao =
          isAdministradorGeral || user.User.Emitente.tipo_pacote > 1;
        const possuiAcessoDashboardFinanceiro =
          user.User.Emitente.tipo_pacote > 1 &&
          possuiPermissaoDashboardFinanceiro;

        if (possuiAcessoDashboardFinanceiro) {
          dashboardFinanceiroModulo = {
            ordem: 4,
            sectionTitle: "Dashboard Financeiro",
            route: `/${utils.getWL()}/financeiro/dashboard-financeiro`,
            activeRoutes: [
              `/${utils.getWL()}/financeiro/dashboard-financeiro`,
              `/${utils.getWL()}/financeiro/dre-gerencial`,
              `/${utils.getWL()}/financeiro/indicadores`,
              `/${utils.getWL()}/financeiro/relatorios`,
            ],
            svgIcon: "media/icons/duotune/finance/fin006.svg",
            fontIcon: "bi-graph-up-arrow",
            sub: [
              {
                heading: "Dashboard Financeiro",
                route: `/${utils.getWL()}/financeiro/dashboard-financeiro/consultar`,
              },
              {
                heading: "DRE Gerencial",
                route: `/${utils.getWL()}/financeiro/dre-gerencial/consultar`,
              },
              {
                heading: "Indicadores",
                route: `/${utils.getWL()}/financeiro/indicadores/consultar`,
              },
              {
                heading: "Relatórios",
                route: `/${utils.getWL()}/financeiro/relatorios/consultar`,
              },
              {
                heading: "Conciliação Bancária",
                route: `/${utils.getWL()}/financeiro/conciliacao-bancaria/consultar`,
              },
            ],
          };

          dashboardFinanceiroModulo.sub = dashboardFinanceiroModulo.sub.filter(
            (item) =>
              item.route !==
              `/${utils.getWL()}/financeiro/conciliacao-bancaria/consultar`
          );

          conciliacaoBancariaModulo = {
            ordem: 1,
            sectionTitle: "Conciliação Bancária",
            route: `/${utils.getWL()}/financeiro/conciliacao-bancaria`,
            svgIcon: "media/icons/duotune/finance/fin001.svg",
            fontIcon: "bi-bank",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/conciliacao-bancaria/consultar`,
              },
              {
                heading: "Relatorios",
                route: `/${utils.getWL()}/financeiro/conciliacao-bancaria/relatorios/consultar`,
              },
              {
                heading: "Bancos",
                route: `/${utils.getWL()}/financeiro/conciliacao-bancaria/bancos`,
              },
            ],
          };

          dashboardFinanceiroRota = {
            path: "/:url/financeiro/dashboard-financeiro/consultar",
            name: "financeiro/dashboard-financeiro/consultar",
            component: () =>
              import("@/views/financeiro/DashboardFinanceiro.vue"),
            meta: {
              pageTitle: "Dashboard Financeiro",
              breadcrumbs: ["Financeiro", "Dashboard Financeiro"],
            },
          };

          dreGerencialRota = {
            path: "/:url/financeiro/dre-gerencial/consultar",
            name: "financeiro/dre-gerencial/consultar",
            component: () =>
              import("@/views/financeiro/DashboardFinanceiro.vue"),
            meta: {
              pageTitle: "DRE Gerencial",
              breadcrumbs: ["Financeiro", "DRE Gerencial"],
            },
          };

          indicadoresFinanceirosRota = {
            path: "/:url/financeiro/indicadores/consultar",
            name: "financeiro/indicadores/consultar",
            component: () =>
              import("@/views/financeiro/DashboardFinanceiro.vue"),
            meta: {
              pageTitle: "Indicadores Financeiros",
              breadcrumbs: ["Financeiro", "Indicadores"],
            },
          };

          relatoriosFinanceirosRota = {
            path: "/:url/financeiro/relatorios/consultar",
            name: "financeiro/relatorios/consultar",
            component: () =>
              import("@/views/financeiro/DashboardFinanceiro.vue"),
            meta: {
              pageTitle: "Relatórios Financeiros",
              breadcrumbs: ["Dashboard Financeiro", "Relatórios"],
            },
          };

          financeiro.pages.push(dashboardFinanceiroModulo);
          rotas.push(dashboardFinanceiroRota);
          rotas.push(dreGerencialRota);
          rotas.push(indicadoresFinanceirosRota);
          rotas.push(relatoriosFinanceirosRota);
          conciliacaoBancariaRota = {
            path: "/:url/financeiro/conciliacao-bancaria/consultar",
            name: "financeiro/conciliacao-bancaria/consultar",
            component: () =>
              import("@/views/financeiro/ConciliacaoBancaria.vue"),
            meta: {
              pageTitle: "Conciliação Bancária",
              breadcrumbs: ["Financeiro", "Conciliação Bancária"],
            },
          };

          let conciliacaoBancariaBancosRota = {
            path: "/:url/financeiro/conciliacao-bancaria/bancos",
            name: "financeiro/conciliacao-bancaria/bancos",
            component: () => import("@/views/financeiro/Bancos.vue"),
            meta: {
              pageTitle: "Bancos",
              breadcrumbs: ["Financeiro", "Conciliacao Bancaria", "Bancos"],
            },
          };

          let conciliacaoBancariaRelatoriosRota = {
            path: "/:url/financeiro/conciliacao-bancaria/relatorios/consultar",
            name: "financeiro/conciliacao-bancaria/relatorios/consultar",
            component: () =>
              import("@/views/financeiro/relatorios/Consultar.vue"),
            meta: {
              pageTitle: "Relatorios da Conciliacao Bancaria",
              breadcrumbs: ["Financeiro", "Conciliacao Bancaria", "Relatorios"],
            },
          };

          if (possuiPermissaoConciliacaoBancaria) {
            financeiro.pages.push(conciliacaoBancariaModulo);
            rotas.push(conciliacaoBancariaRota);
            rotas.push(conciliacaoBancariaBancosRota);
            rotas.push(conciliacaoBancariaRelatoriosRota);
          }
        }

        if (user.User.Emitente.tipo_pacote > 1 && possuiPermissaoFluxoCaixa) {
          fluxoCaixaModulo = {
            ordem: 5,
            sectionTitle: "Fluxo de Caixa",
            route: `/${utils.getWL()}/financeiro/fluxo-caixa`,
            activeRoutes: [`/${utils.getWL()}/financeiro/fluxo-caixa`],
            svgIcon: "media/icons/duotune/finance/fin009.svg",
            fontIcon: "bi-cash-stack",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/fluxo-caixa/consultar`,
              },
            ],
          };

          fluxoCaixaRota = {
            path: "/:url/financeiro/fluxo-caixa/consultar",
            name: "financeiro/fluxo-caixa/consultar",
            component: () => import("@/views/financeiro/FluxoCaixa.vue"),
            meta: {
              pageTitle: "Fluxo de Caixa",
              breadcrumbs: ["Financeiro", "Fluxo de Caixa"],
            },
          };

          financeiro.pages.push(fluxoCaixaModulo);
          rotas.push(fluxoCaixaRota);
        }

        if (
          possuiAcessoPacoteConciliacao &&
          !possuiAcessoDashboardFinanceiro &&
          possuiPermissaoConciliacaoBancaria
        ) {
          conciliacaoBancariaModulo = {
            ordem: 1,
            sectionTitle: "Conciliação Bancária",
            route: `/${utils.getWL()}/financeiro/conciliacao-bancaria`,
            svgIcon: "media/icons/duotune/finance/fin001.svg",
            fontIcon: "bi-bank",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/conciliacao-bancaria/consultar`,
              },
              {
                heading: "Relatorios",
                route: `/${utils.getWL()}/financeiro/conciliacao-bancaria/relatorios/consultar`,
              },
              {
                heading: "Bancos",
                route: `/${utils.getWL()}/financeiro/conciliacao-bancaria/bancos`,
              },
            ],
          };

          conciliacaoBancariaRota = {
            path: "/:url/financeiro/conciliacao-bancaria/consultar",
            name: "financeiro/conciliacao-bancaria/consultar",
            component: () =>
              import("@/views/financeiro/ConciliacaoBancaria.vue"),
            meta: {
              pageTitle: "Conciliação Bancária",
              breadcrumbs: ["Financeiro", "Conciliação Bancária"],
            },
          };

          let conciliacaoBancariaBancosRota = {
            path: "/:url/financeiro/conciliacao-bancaria/bancos",
            name: "financeiro/conciliacao-bancaria/bancos",
            component: () => import("@/views/financeiro/Bancos.vue"),
            meta: {
              pageTitle: "Bancos",
              breadcrumbs: ["Financeiro", "Conciliacao Bancaria", "Bancos"],
            },
          };

          let conciliacaoBancariaRelatoriosRota = {
            path: "/:url/financeiro/conciliacao-bancaria/relatorios/consultar",
            name: "financeiro/conciliacao-bancaria/relatorios/consultar",
            component: () =>
              import("@/views/financeiro/relatorios/Consultar.vue"),
            meta: {
              pageTitle: "Relatorios da Conciliacao Bancaria",
              breadcrumbs: ["Financeiro", "Conciliacao Bancaria", "Relatorios"],
            },
          };

          financeiro.pages.push(conciliacaoBancariaModulo);
          rotas.push(conciliacaoBancariaRota);
          rotas.push(conciliacaoBancariaBancosRota);
          rotas.push(conciliacaoBancariaRelatoriosRota);
        }
        //#endregion

        //#region Menu - Financeiro - Condições
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Condicao.Consultar"
          )
        ) {
          condicoesModulo = {
            ordem: 5,
            sectionTitle: "Condições",
            route: `/${utils.getWL()}/financeiro/condicoes`,
            svgIcon: "media/icons/duotune/ecommerce/ecm008.svg",
            fontIcon: "bi-journal-text",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/condicoes/consultar`,
              },
            ],
          };

          condicoesRota = {
            path: "/:url/financeiro/condicoes/consultar",
            name: "financeiro/condicoes/consultar",
            component: () => import("@/views/condicoes/Consultar.vue"),
            meta: {
              pageTitle: "Condições",
              breadcrumbs: ["Consultar"],
            },
          };

          financeiro.pages.push(condicoesModulo);
          rotas.push(condicoesRota);
        }
        //#endregion

        //#region Menu - Financeiro - Espécies
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Especie.Consultar"
          )
        ) {
          especiesModulo = {
            ordem: 6,
            sectionTitle: "Espécies",
            route: `/${utils.getWL()}/financeiro/especies`,
            svgIcon: "media/icons/duotune/finance/fin008.svg",
            fontIcon: "bi-wallet2",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/especies/consultar`,
              },
            ],
          };

          especiesRota = {
            path: "/:url/financeiro/especies/consultar",
            name: "financeiro/especies/consultar",
            component: () => import("@/views/especies/Consultar.vue"),
            meta: {
              pageTitle: "Espécies",
              breadcrumbs: ["Consultar"],
            },
          };

          financeiro.pages.push(especiesModulo);
          rotas.push(especiesRota);
        }
        //#endregion

        //#region Menu - Financeiro - Centro de Custo
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Custo.Consultar"
          )
        ) {
          custosModulo = {
            ordem: 8,
            sectionTitle: "Centro de Custo",
            route: `/${utils.getWL()}/financeiro/custos`,
            svgIcon: "media/icons/duotune/general/gen028.svg",
            fontIcon: "bi-journals",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/custos/consultar`,
              },
            ],
          };

          custosRota = {
            path: "/:url/financeiro/custos/consultar",
            name: "financeiro/custos/consultar",
            component: () => import("@/views/custos/Consultar.vue"),
            meta: {
              pageTitle: "Centro de Custo",
              breadcrumbs: ["Consultar"],
            },
          };

          financeiro.pages.push(custosModulo);
          rotas.push(custosRota);
        }
        //#endregion

        //#region Menu - Financeiro - Plano de Contas
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Conta.Consultar"
          )
        ) {
          contasModulo = {
            ordem: 7,
            sectionTitle: "Plano de Contas",
            route: `/${utils.getWL()}/financeiro/contas`,
            svgIcon: "media/icons/duotune/files/fil002.svg",
            fontIcon: "bi-calendar3",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/financeiro/contas/consultar`,
              },
            ],
          };

          contasRota = {
            path: "/:url/financeiro/contas/consultar",
            name: "financeiro/contas/consultar",
            component: () => import("@/views/contas/Consultar.vue"),
            meta: {
              pageTitle: "Plano de Contas",
              breadcrumbs: ["Consultar"],
            },
          };

          financeiro.pages.push(contasModulo);
          rotas.push(contasRota);
        }
        //#endregion

        //#region Menu - Financeiro - Contas a Receber
        if (user.User.Emitente.tipo_pacote > 1) {
          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Receber.Consultar"
            )
          ) {
            receberModulo = {
              ordem: 2,
              sectionTitle: "Contas a Receber",
              route: `/${utils.getWL()}/financeiro/receber`,
              svgIcon: "media/icons/duotune/files/fil018.svg",
              fontIcon: "bi-file-arrow-up",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/financeiro/receber/consultar`,
                },
                {
                  heading: "Boletos Bancários",
                  route: `/${utils.getWL()}/financeiro/receber/boletos`,
                },
              ],
            };

            receberRota = {
              path: "/:url/financeiro/receber/consultar",
              name: "financeiro/receber/consultar",
              component: () => import("@/views/receber/Consultar.vue"),
              meta: {
                pageTitle: "Contas a Receber",
                breadcrumbs: ["Consultar"],
              },
            };

            financeiro.pages.push(receberModulo);
            rotas.push(receberRota);

            rotas.push({
              path: "/:url/financeiro/receber/boletos",
              name: "financeiro/receber/boletos",
              component: () => import("@/views/receber/boletos/Gerenciar.vue"),
              meta: {
                pageTitle: "Boletos Bancários",
                breadcrumbs: ["Contas a Receber", "Boletos Bancários"],
              },
            });
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Receber.Relatorios"
            )
          ) {
            let receberRelatoriosModulo = {
              heading: "Relatórios",
              route: `/${utils.getWL()}/financeiro/receber/relatorios/consultar`,
            };

            let receberRelatoriosRota = {
              path: "/:url/financeiro/receber/relatorios/consultar",
              name: "financeiro/receber/relatorios/consultar",
              component: () =>
                import("@/views/receber/relatorios/Consultar.vue"),
              meta: {
                pageTitle: "Relatórios de Contas a Receber",
                breadcrumbs: ["Contas a Receber", "Relatórios"],
              },
            };

            if (receberModulo !== null) {
              receberModulo.sub.push(receberRelatoriosModulo);
            }
            rotas.push(receberRelatoriosRota);
          }
        }
        //#endregion

        //#region Menu - Financeiro - Contas a Pagar
        if (user.User.Emitente.tipo_pacote > 1) {
          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pagar.Consultar"
            )
          ) {
            pagarModulo = {
              ordem: 3,
              sectionTitle: "Contas a Pagar",
              route: `/${utils.getWL()}/financeiro/pagar`,
              svgIcon: "media/icons/duotune/files/fil017.svg",
              fontIcon: "bi-file-arrow-down",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/financeiro/pagar/consultar`,
                },
              ],
            };

            pagarRota = {
              path: "/:url/financeiro/pagar/consultar",
              name: "financeiro/pagar/consultar",
              component: () => import("@/views/pagar/Consultar.vue"),
              meta: {
                pageTitle: "Contas a Pagar",
                breadcrumbs: ["Consultar"],
              },
            };

            financeiro.pages.push(pagarModulo);
            rotas.push(pagarRota);
          }

          if (
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.Pagar.Relatorios"
            )
          ) {
            let pagarRelatoriosModulo = {
              heading: "Relatórios",
              route: `/${utils.getWL()}/financeiro/pagar/relatorios/consultar`,
            };

            let pagarRelatoriosRota = {
              path: "/:url/financeiro/pagar/relatorios/consultar",
              name: "financeiro/pagar/relatorios/consultar",
              component: () => import("@/views/pagar/relatorios/Consultar.vue"),
              meta: {
                pageTitle: "Relatórios de Contas a Pagar",
                breadcrumbs: ["Contas a Pagar", "Relatórios"],
              },
            };

            if (pagarModulo !== null) {
              pagarModulo.sub.push(pagarRelatoriosModulo);
            }
            rotas.push(pagarRelatoriosRota);
          }
        }
        //#endregion

        //#endregion

        //#region Menu - Relatórios

        //#region Menu - Relatórios - Relatórios
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Relatorios.Executar"
          )
        ) {
          if (relatoriosModulo === null) {
            relatoriosModulo = {
              ordem: 1,
              sectionTitle: "Relatórios",
              route: `/${utils.getWL()}/relatorios`,
              svgIcon: "media/icons/duotune/graphs/gra012.svg",
              fontIcon: "bi-clipboard-data",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/relatorios/consultar`,
                },
              ],
            };
          } else {
            let consultarRelatoriosModulo = {
              heading: "Consultar",
              route: `/${utils.getWL()}/relatorios/consultar`,
            };
            relatoriosModulo.sub.push(consultarRelatoriosModulo);
          }

          relatoriosRota = {
            path: "/:url/relatorios/consultar",
            name: "relatorios/consultar",
            component: () => import("@/views/relatorios/Consultar.vue"),
            meta: {
              pageTitle: "Relatorios",
              breadcrumbs: ["Consultar"],
            },
          };

          relatorios.pages.push(relatoriosModulo);
          rotas.push(relatoriosRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Relatorios.Consultar"
          )
        ) {
          let consultarRelatoriosModulo = {
            heading: "Gerenciar",
            route: `/${utils.getWL()}/relatorios/gerenciar`,
          };

          let consultarRelatoriosRotas = {
            path: "/:url/relatorios/gerenciar",
            name: "relatorios/gerenciar",
            component: () => import("@/views/relatorios/Gerenciar.vue"),
            meta: {
              pageTitle: "Gerenciar",
              breadcrumbs: ["Relatórios", "Gerenciar"],
            },
          };

          if (relatoriosModulo !== null) {
            relatoriosModulo.sub.push(consultarRelatoriosModulo);
          } else {
            relatoriosModulo = {
              ordem: 1,
              sectionTitle: "Relatórios",
              route: `/${utils.getWL()}/relatorios`,
              svgIcon: "media/icons/duotune/graphs/gra012.svg",
              fontIcon: "bi-clipboard-data",
              sub: [
                {
                  heading: "Gerenciar",
                  route: `/${utils.getWL()}/relatorios/gerenciar`,
                },
              ],
            };
          }

          rotas.push(consultarRelatoriosRotas);
        }
        //#endregion

        //#endregion

        //#region Menu - Configurações

        //#region Menu - Configurações - Usuários
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Usuario.Consultar"
          )
        ) {
          usuariosModulo = {
            ordem: 1,
            sectionTitle: "Usuários",
            route: `/${utils.getWL()}/configuracoes/usuarios`,
            svgIcon: "media/icons/duotune/communication/com006.svg",
            fontIcon: "bi-person-circle",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/configuracoes/usuarios/consultar`,
              },
            ],
          };

          usuariosRota = {
            path: "/:url/configuracoes/usuarios/consultar",
            name: "configuracoes/usuarios/consultar",
            component: () => import("@/views/usuarios/Consultar.vue"),
            meta: {
              pageTitle: "Usuários",
              breadcrumbs: ["Consultar"],
            },
          };

          configuracoes.pages.push(usuariosModulo);
          rotas.push(usuariosRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Usuario.Incluir"
          )
        ) {
          var usuariosAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/configuracoes/usuarios/editar`,
          };

          var usuariosAdicionarRotas = {
            path: "/:url/configuracoes/usuarios/editar",
            name: "configuracoes/usuarios/editar",
            component: () => import("@/views/usuarios/Editar.vue"),
            meta: {
              pageTitle: "Usuários",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (usuariosModulo !== null) {
            usuariosModulo.sub.push(usuariosAdicionarModulo);
          }

          rotas.push(usuariosAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Usuario.Alterar"
          )
        ) {
          var usuariosEditarRotas = {
            path: "/:url/configuracoes/usuarios/editar/:id",
            name: "configuracoes/usuarios/editar/:id",
            component: () => import("@/views/usuarios/Editar.vue"),
            meta: {
              pageTitle: "Usuários",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(usuariosEditarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.SessaoUsuario.Consultar"
          )
        ) {
          let sessaoUsuarioModulo = {
            heading: "Usuários Conectados",
            route: `/${utils.getWL()}/configuracoes/usuarios/sessaousuario`,
          };

          let sessaoUsuarioRotas = {
            path: "/:url/configuracoes/usuarios/sessaousuario",
            name: "configuracoes/usuarios/sessaousuario",
            component: () => import("@/views/sessaousuarios/Consultar.vue"),
            meta: {
              pageTitle: "Usuários Conectados",
              breadcrumbs: ["Usuários", "Usuários Conectados"],
            },
          };

          if (usuariosModulo !== null) {
            usuariosModulo.sub.push(sessaoUsuarioModulo);
          }

          rotas.push(sessaoUsuarioRotas);
        }
        //#endregion

        //#region Menu - Configurações - Restrições de Usuários
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.EmitenteRestricao.Consultar"
          )
        ) {
          emitenteRestricoesModulo = {
            ordem: 2,
            sectionTitle: "Restrições de Usuários",
            route: `/${utils.getWL()}/configuracoes/emitenterestricoes`,
            svgIcon: "media/icons/duotune/general/gen049.svg",
            fontIcon: "bi-shield-x",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/configuracoes/emitenterestricoes/consultar`,
              },
            ],
          };

          emitenteRestricoesRota = {
            path: "/:url/configuracoes/emitenterestricoes/consultar",
            name: "configuracoes/emitenterestricoes/consultar",
            component: () => import("@/views/emitenterestricoes/Consultar.vue"),
            meta: {
              pageTitle: "Restrições de usuários",
              breadcrumbs: ["Consultar"],
            },
          };

          configuracoes.pages.push(emitenteRestricoesModulo);
          rotas.push(emitenteRestricoesRota);
        }

        if (
          permissoes.find(
            (modulo) =>
              modulo.regra == "Permitir.EmitenteRestricaoPadrao.Consultar"
          )
        ) {
          var emitenteRestricoesPadraoConsultarModulo = {
            heading: "Gerenciar",
            route: `/${utils.getWL()}/configuracoes/emitenterestricoes/gerenciar`,
          };

          var emitenteRestricoesPadraoConsultarRotas = {
            path: "/:url/configuracoes/emitenterestricoes/gerenciar",
            name: "configuracoes/emitenterestricoes/gerenciar",
            component: () => import("@/views/emitenterestricoes/Gerenciar.vue"),
            meta: {
              pageTitle: "Restrições de usuários",
              breadcrumbs: ["Consultar", "Gerenciar"],
            },
          };

          if (emitenteRestricoesModulo !== null) {
            emitenteRestricoesModulo.sub.push(
              emitenteRestricoesPadraoConsultarModulo
            );
          }

          rotas.push(emitenteRestricoesPadraoConsultarRotas);
        }
        //#endregion

        //#region Menu - Configurações - Configurações
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Configuracao.Consultar"
          )
        ) {
          configuracoesModulo = {
            ordem: 3,
            sectionTitle: "Configurações",
            route: `/${utils.getWL()}/configuracoes/configuracoes`,
            svgIcon: "media/icons/duotune/coding/cod001.svg",
            fontIcon: "bi bi-gear",
            sub: [
              {
                heading: "Gerenciar",
                route: `/${utils.getWL()}/configuracoes/configuracoes/gerenciar`,
              },
            ],
          };

          configuracoesRota = {
            path: "/:url/configuracoes/configuracoes/gerenciar",
            name: "configuracoes/configuracoes/gerenciar",
            component: () => import("@/views/configuracoes/Gerenciar.vue"),
            meta: {
              pageTitle: "Configurações",
              breadcrumbs: ["Gerenciar"],
            },
          };

          configuracoes.pages.push(configuracoesModulo);
          rotas.push(configuracoesRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Emitente.Consultar"
          )
        ) {
          var emitenteGerenciarModulo = {
            heading: "Emitente",
            route: `/${utils.getWL()}/configuracoes/emitente/gerenciar`,
          };

          var emitenteGerenciarRotas = {
            path: "/:url/configuracoes/emitente/gerenciar",
            name: "configuracoes/emitente/gerenciar",
            component: () => import("@/views/empresas/Editar.vue"),
            meta: {
              pageTitle: "Emitente",
              breadcrumbs: ["Gerenciar"],
            },
          };

          if (configuracoesModulo !== null) {
            configuracoesModulo.sub.push(emitenteGerenciarModulo);
          }

          rotas.push(emitenteGerenciarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Conversao.Gerenciar"
          )
        ) {
          var conversaoGerenciarModulo = {
            heading: "Conversões",
            route: `/${utils.getWL()}/configuracoes/conversao/gerenciar`,
          };

          var conversaoGerenciarRotas = {
            path: "/:url/configuracoes/conversao/gerenciar",
            name: "configuracoes/conversao/gerenciar",
            component: () => import("@/views/conversao/Gerenciar.vue"),
            meta: {
              pageTitle: "Conversões",
              breadcrumbs: ["Gerenciar"],
            },
          };

          if (configuracoesModulo !== null) {
            configuracoesModulo.sub.push(conversaoGerenciarModulo);
          }

          rotas.push(conversaoGerenciarRotas);
        }

        if (exbirRestaurante && configuracoesModulo !== null) {
          var gwayAgenteConsultarModulo = {
            heading: "Gway Agente",
            route: `/${utils.getWL()}/configuracoes/gway-agente/consultar`,
          };

          var gwayAgenteConsultarRota = {
            path: "/:url/configuracoes/gway-agente/consultar",
            name: "configuracoes/gway-agente/consultar",
            component: () => import("@/views/gway-agente/Consultar.vue"),
            meta: {
              pageTitle: "Gway Agente",
              breadcrumbs: ["Consultar"],
            },
          };

          configuracoesModulo.sub.push(gwayAgenteConsultarModulo);
          rotas.push(gwayAgenteConsultarRota);
        }
        //#endregion

        //#region Menu - Configurações - Auditoria
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Auditoria.Consultar"
          )
        ) {
          auditoriaModulo = {
            ordem: 4,
            sectionTitle: "Auditoria",
            route: `/${utils.getWL()}/configuracoes/auditoria`,
            svgIcon: "media/icons/duotune/general/gen062.svg",
            fontIcon: "bi-pc-display-horizontal",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/configuracoes/auditoria/consultar`,
              },
            ],
          };

          auditoriaRota = {
            path: "/:url/configuracoes/auditoria/consultar",
            name: "configuracoes/auditoria/consultar",
            component: () => import("@/views/auditoria/Consultar.vue"),
            meta: {
              pageTitle: "Auditoria",
              breadcrumbs: ["Consultar"],
            },
          };

          configuracoes.pages.push(auditoriaModulo);
          rotas.push(auditoriaRota);
        }
        //#endregion

        //#endregion

        //#region Menu - Fiscal
        if (
          isAdministradorGeral ||
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Sintegra.Consultar"
          )
        ) {
          sintegraModulo = {
            ordem: 1,
            sectionTitle: "Sintegra",
            route: `/${utils.getWL()}/fiscal/sintegra/consultar`,
            svgIcon: "media/icons/duotune/abstract/abs038.svg",
            fontIcon: "bi bi-file-earmark-text",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/fiscal/sintegra/consultar`,
              },
            ],
          };

          sintegraRota = {
            path: "/:url/fiscal/sintegra/consultar",
            name: "fiscal/sintegra/consultar",
            component: () => import("@/views/fiscal/sintegra/Consultar.vue"),
            meta: {
              pageTitle: "Sintegra",
              breadcrumbs: ["Fiscal", "Sintegra", "Consultar"],
            },
          };

          fiscal.pages.push(sintegraModulo);
          rotas.push(sintegraRota);
        }

        spedSubmenus = [];

        if (
          user.User.Emitente.tipo_pacote > 1 &&
          (isAdministradorGeral ||
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.SpedContribuicoes.Consultar"
            ))
        ) {
          spedSubmenus.push({
            heading: "Contribuições",
            route: `/${utils.getWL()}/fiscal/sped/contribuicoes/consultar`,
            activeRoutes: [`/${utils.getWL()}/fiscal/sped/contribuicoes/`],
          });

          spedContribuicoesRota = {
            path: "/:url/fiscal/sped/contribuicoes/consultar",
            name: "fiscal/sped/contribuicoes/consultar",
            component: () =>
              import("@/views/fiscal/sped/contribuicoes/Consultar.vue"),
            meta: {
              pageTitle: "SPED Contribuições",
              breadcrumbs: ["Fiscal", "SPED", "Contribuições"],
            },
          };

          rotas.push(spedContribuicoesRota);
        }

        if (
          user.User.Emitente.tipo_pacote > 1 &&
          (isAdministradorGeral ||
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.SpedContabilista.Consultar"
            ))
        ) {
          spedSubmenus.push({
            heading: "Contabilista",
            route: `/${utils.getWL()}/fiscal/sped/contabilista`,
            activeRoutes: [`/${utils.getWL()}/fiscal/sped/contabilista`],
          });

          spedContabilistaRota = {
            path: "/:url/fiscal/sped/contabilista",
            name: "fiscal/sped/contabilista",
            component: () => import("@/views/fiscal/sped/Contabilista.vue"),
            meta: {
              pageTitle: "Contabilista",
              breadcrumbs: ["Fiscal", "SPED", "Contabilista"],
            },
          };

          rotas.push(spedContabilistaRota);
        }

        if (
          user.User.Emitente.tipo_pacote > 1 &&
          (isAdministradorGeral ||
            permissoesEmitente.find(
              (modulo) => modulo.regra == "Permitir.SpedFiscal.Consultar"
            ))
        ) {
          spedSubmenus.push({
            heading: "Fiscal",
            route: `/${utils.getWL()}/fiscal/sped/fiscal`,
            activeRoutes: [
              `/${utils.getWL()}/fiscal/sped/fiscal`,
              `/${utils.getWL()}/fiscal/sped/fiscal/bloco-k`,
            ],
          });

          spedFiscalRota = {
            path: "/:url/fiscal/sped/fiscal",
            name: "fiscal/sped/fiscal",
            component: () => import("@/views/fiscal/sped/fiscal/Consultar.vue"),
            meta: {
              pageTitle: "SPED Fiscal",
              breadcrumbs: ["Fiscal", "SPED", "Fiscal"],
            },
          };

          rotas.push(spedFiscalRota);
          rotas.push({
            path: "/:url/fiscal/sped/fiscal/bloco-k",
            name: "fiscal/sped/fiscal/bloco-k",
            component: () =>
              import("@/views/fiscal/sped/fiscal/BlocoKConsultar.vue"),
            meta: {
              pageTitle: "Registros Bloco K",
              breadcrumbs: ["Fiscal", "SPED", "Fiscal", "Bloco K"],
            },
          });
        }

        if (spedSubmenus.length > 0) {
          spedModulo = {
            ordem: 2,
            sectionTitle: "SPED",
            route: spedSubmenus[0].route,
            activeRoutes: [`/${utils.getWL()}/fiscal/sped/`],
            svgIcon: "media/icons/duotune/maps/map004.svg",
            fontIcon: "bi bi-folder2-open",
            sub: spedSubmenus,
          };

          fiscal.pages.push(spedModulo);
        }
        //#endregion

        //#region Menu - Suporte

        //#region Menu - Suporte - Ajuda
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Ajuda.Consultar"
          )
        ) {
          suporteAjudaModulo = {
            ordem: 1,
            sectionTitle: "Ajuda",
            route: `/${utils.getWL()}/suporte/ajuda`,
            svgIcon: "media/icons/duotune/general/gen046.svg",
            fontIcon: "bi-question-circle-fill",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/suporte/ajuda/consultar`,
              },
            ],
          };

          suporteAjudaRota = {
            path: "/:url/suporte/ajuda/consultar",
            name: "suporte/ajuda/consultar",
            component: () => import("@/views/ajuda/ConsultarAjuda.vue"),
            meta: {
              pageTitle: "Ajuda",
              breadcrumbs: ["Consultar"],
            },
          };

          suporte.pages.push(suporteAjudaModulo);
          rotas.push(suporteAjudaRota);
        }
        //#endregion

        //#region Menu - Multiempresas
        if (
          user.User.TipoUsuario.tipo === "Administrador" ||
          user.User.TipoUsuario.tipo === "Distribuidor Master" ||
          user.User.TipoUsuario.tipo === "Distribuidor" ||
          user.User.TipoUsuario.tipo === "Revenda"
        ) {
          multiempresaGestaoModulo = {
            ordem: 7,
            sectionTitle: "Multiempresas",
            route: `/${utils.getWL()}/multiempresas/grupos/consultar`,
            svgIcon: "media/icons/duotune/abstract/abs042.svg",
            fontIcon: "bi-diagram-3",
            sub: [
              {
                heading: "Configuração",
                route: `/${utils.getWL()}/multiempresas/grupos/consultar`,
              },
            ],
          };

          navegacao.pages.push(multiempresaGestaoModulo);
          rotas.push({
            path: "/:url/multiempresas/grupos/consultar",
            name: "multiempresas/grupos/consultar",
            component: () => import("@/views/multiempresas/Consultar.vue"),
            meta: {
              pageTitle: "Configuração de Grupos",
              breadcrumbs: [
                "Gestão",
                "Multiempresas",
                "Configuração de Grupos",
              ],
            },
          });
        }

        if (possuiAcessoRelatoriosMultiempresa) {
          rotas.push({
            path: "/:url/multiempresas/estoque/consultar",
            name: "multiempresas/estoque/consultar",
            component: () => import("@/views/multiempresas/Estoque.vue"),
            meta: {
              pageTitle: "Estoque Consolidado",
              breadcrumbs: ["Multiempresas", "Estoque Consolidado"],
            },
          });

          multiempresaRelatoriosModulo = {
            ordem: 1,
            sectionTitle: "Relatórios Unificados",
            route: `/${utils.getWL()}/multiempresas/relatorios/dashboard`,
            activeRoutes: [`/${utils.getWL()}/multiempresas/relatorios/`],
            svgIcon: "media/icons/duotune/graphs/gra006.svg",
            fontIcon: "bi-bar-chart",
            sub: [
              {
                heading: "Dashboard Financeiro",
                route: `/${utils.getWL()}/multiempresas/relatorios/dashboard`,
              },
              {
                heading: "Relatórios",
                route: `/${utils.getWL()}/multiempresas/relatorios/consultar`,
                activeRoutes: [
                  `/${utils.getWL()}/multiempresas/relatorios/consultar`,
                  `/${utils.getWL()}/multiempresas/relatorios/dre`,
                  `/${utils.getWL()}/multiempresas/relatorios/vendas`,
                  `/${utils.getWL()}/multiempresas/relatorios/produtos-servicos`,
                  `/${utils.getWL()}/multiempresas/relatorios/fluxo-caixa`,
                  `/${utils.getWL()}/multiempresas/relatorios/inadimplencia`,
                  `/${utils.getWL()}/multiempresas/relatorios/curva-abc`,
                ],
              },
            ],
          };

          multiempresas.pages.push(multiempresaRelatoriosModulo);
          rotas.push({
            path: "/:url/multiempresas/relatorios/dashboard",
            name: "multiempresas/relatorios/dashboard",
            component: () => import("@/views/multiempresas/Dashboard.vue"),
            meta: {
              pageTitle: "Dashboard Financeiro",
              breadcrumbs: ["Multiempresas", "Relatórios Unificados"],
            },
          });
          rotas.push({
            path: "/:url/multiempresas/relatorios/consultar",
            name: "multiempresas/relatorios/consultar",
            component: () => import("@/views/multiempresas/Relatorios.vue"),
            meta: {
              pageTitle: "Relatórios",
              breadcrumbs: [
                "Multiempresas",
                "Relatórios Unificados",
                "Relatórios",
              ],
            },
          });
          rotas.push({
            path: "/:url/multiempresas/relatorios/dre",
            name: "multiempresas/relatorios/dre",
            component: () => import("@/views/multiempresas/Dre.vue"),
            meta: {
              pageTitle: "DRE Consolidado",
              breadcrumbs: [
                "Multiempresas",
                "Relatórios Unificados",
                "DRE Consolidado",
              ],
            },
          });
          rotas.push({
            path: "/:url/multiempresas/relatorios/vendas",
            name: "multiempresas/relatorios/vendas",
            component: () => import("@/views/multiempresas/Vendas.vue"),
            meta: {
              pageTitle: "Vendas Consolidadas",
              breadcrumbs: [
                "Multiempresas",
                "Relatórios Unificados",
                "Vendas Consolidadas",
              ],
            },
          });
          rotas.push({
            path: "/:url/multiempresas/relatorios/produtos-servicos",
            name: "multiempresas/relatorios/produtos-servicos",
            component: () =>
              import("@/views/multiempresas/ProdutosServicos.vue"),
            meta: {
              pageTitle: "Produtos e Serviços",
              breadcrumbs: [
                "Multiempresas",
                "Relatórios Unificados",
                "Produtos e Serviços",
              ],
            },
          });
          rotas.push({
            path: "/:url/multiempresas/relatorios/fluxo-caixa",
            name: "multiempresas/relatorios/fluxo-caixa",
            component: () => import("@/views/multiempresas/FluxoCaixa.vue"),
            meta: {
              pageTitle: "Fluxo de Caixa Consolidado",
              breadcrumbs: [
                "Multiempresas",
                "Relatórios Unificados",
                "Fluxo de Caixa Consolidado",
              ],
            },
          });
          rotas.push({
            path: "/:url/multiempresas/relatorios/inadimplencia",
            name: "multiempresas/relatorios/inadimplencia",
            component: () => import("@/views/multiempresas/Inadimplencia.vue"),
            meta: {
              pageTitle: "Inadimplência Consolidada",
              breadcrumbs: [
                "Multiempresas",
                "Relatórios Unificados",
                "Inadimplência Consolidada",
              ],
            },
          });
          rotas.push({
            path: "/:url/multiempresas/relatorios/curva-abc",
            name: "multiempresas/relatorios/curva-abc",
            component: () => import("@/views/multiempresas/CurvaABC.vue"),
            meta: {
              pageTitle: "Curva ABC de Produtos",
              breadcrumbs: [
                "Multiempresas",
                "Relatórios Unificados",
                "Curva ABC de Produtos",
              ],
            },
          });
        }

        if (possuiAcessoLogsMultiempresa) {
          multiempresaLogsModulo = {
            ordem: 2,
            sectionTitle: "Log de Sincronização",
            route: `/${utils.getWL()}/multiempresas/logs/consultar`,
            svgIcon: "media/icons/duotune/coding/cod002.svg",
            fontIcon: "bi-journal-text",
            sub: [
              {
                heading: "Logs",
                route: `/${utils.getWL()}/multiempresas/logs/consultar`,
              },
            ],
          };

          multiempresas.pages.push(multiempresaLogsModulo);
          rotas.push({
            path: "/:url/multiempresas/logs/consultar",
            name: "multiempresas/logs/consultar",
            component: () => import("@/views/multiempresas/Logs.vue"),
            meta: {
              pageTitle: "Log de Sincronização",
              breadcrumbs: ["Multiempresas", "Log de Sincronização"],
            },
          });
        }
        //#endregion

        //#region Menu - Suporte - Ticket
        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Ticket.Consultar"
          )
        ) {
          ticketModulo = {
            ordem: 2,
            sectionTitle: "Ticket",
            route: `/${utils.getWL()}/suporte/ticket`,
            svgIcon: "media/icons/duotune/communication/com007.svg",
            fontIcon: "bi-chat-left-text",
            sub: [
              {
                heading: "Consultar",
                route: `/${utils.getWL()}/suporte/ticket/consultar`,
              },
            ],
          };

          ticketRota = {
            path: "/:url/suporte/ticket/consultar",
            name: "suporte/ticket/consultar",
            component: () => import("@/views/tickets/Consultar.vue"),
            meta: {
              pageTitle: "Ticket",
              breadcrumbs: ["Consultar"],
            },
          };

          suporte.pages.push(ticketModulo);
          rotas.push(ticketRota);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Ticket.Incluir"
          )
        ) {
          var ticketAdicionarModulo = {
            heading: "Adicionar",
            route: `/${utils.getWL()}/suporte/ticket/editar`,
          };

          var ticketAdicionarRotas = {
            path: "/:url/suporte/ticket/editar",
            name: "suporte/ticket/editar",
            component: () => import("@/views/tickets/Editar.vue"),
            meta: {
              pageTitle: "Ticket",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          if (ticketModulo !== null) {
            ticketModulo.sub.push(ticketAdicionarModulo);
          }

          rotas.push(ticketAdicionarRotas);
        }

        if (
          permissoesEmitente.find(
            (modulo) => modulo.regra == "Permitir.Ticket.Alterar"
          )
        ) {
          var ticketEditarRotas = {
            path: "/:url/suporte/ticket/editar/:id",
            name: "suporte/ticket/editar/:id",
            component: () => import("@/views/tickets/Editar.vue"),
            meta: {
              pageTitle: "Ticket",
              breadcrumbs: ["Consultar", "Editar"],
            },
          };

          rotas.push(ticketEditarRotas);
        }
        //#endregion

        //#region Licença

        if (
          user.User.Emitente.Revenda.cnpj === config.revendas.gateway.cnpj ||
          user.User.Emitente.Revenda.cnpj === config.revendas.eedoc.cnpj
        ) {
          if (
            permissoesEmitente.find(
              (modulo) =>
                modulo.regra == "Permitir.LicencaFaturaEmitente.Consultar"
            )
          ) {
            licencaFaturaEmitenteModulo = {
              ordem: 1,
              sectionTitle: "Licença - Fatura",
              route: `/${utils.getWL()}/fatura/licenca`,
              svgIcon: "media/icons/duotune/finance/fin005.svg",
              fontIcon: "bi bi-toggles",
              sub: [
                {
                  heading: "Consultar",
                  route: `/${utils.getWL()}/fatura/licenca/consultar`,
                },
              ],
            };

            licencaFaturaEmitenteRota = {
              path: "/:url/fatura/licenca/consultar",
              name: "fatura/licenca/consultar",
              component: () => import("@/views/licencarecebivel/Consultar.vue"),
              meta: {
                pageTitle: "Licença - Fatura",
                breadcrumbs: ["Consultar"],
              },
            };

            licenca.pages.push(licencaFaturaEmitenteModulo);
            rotas.push(licencaFaturaEmitenteRota);
          }
        }

        //#endregion

        //#endregion

        //#endregion

        //#region Ordenação
        rotas.forEach((rota) => {
          router.addRoute("nav", rota);
        });

        if (navegacao.pages.length > 0) {
          navegacao.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(navegacao);
        }

        if (cadastros.pages.length > 0) {
          cadastros.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(cadastros);
        }

        if (movimentacao.pages.length > 0) {
          movimentacao.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(movimentacao);
        }

        if (financeiro.pages.length > 0) {
          financeiro.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(financeiro);
        }

        if (auxiliares.pages.length > 0) {
          auxiliares.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(auxiliares);
        }

        if (fiscal.pages.length > 0) {
          fiscal.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(fiscal);
        }

        if (relatorios.pages.length > 0) {
          relatorios.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(relatorios);
        }

        if (multiempresas.pages.length > 0) {
          multiempresas.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(multiempresas);
        }

        if (configuracoes.pages.length > 0) {
          configuracoes.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(configuracoes);
        }

        if (suporte.pages.length > 0) {
          suporte.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(suporte);
        }

        if (licenca.pages.length > 0) {
          licenca.pages.sort(function (a, b) {
            return a.ordem - b.ordem;
          });
          DocMenuConfig.push(licenca);
        }

        //#endregion
      } catch (error) {
        console.log(error);
      }
    },
    desmontarMenu({ commit }) {
      DocMenuConfig.splice(0, DocMenuConfig.length);
      DocMenuConfig.push({
        pages: [
          {
            heading: "Dashboard",
            route: `/${utils.getWL()}/dashboard`,
            svgIcon: "media/icons/duotune/art/art002.svg",
            fontIcon: "bi-app-indicator",
          },
        ],
      });
    },
  },
  mutations: {
    montarMenu(state, menu) {
      state.menu = menu;
    },
    desmontarMenu(state) {
      state.menu = [];
    },
  },
};
